import type { BlogArticle, Product, SiteSettings, SeoPage, PageContent, Order, Client } from '../types';

/* ── All 18 Blog Articles from the live site (blog.ts) ────────────────────── */
export const defaultArticles: BlogArticle[] = [

  // ── WEB DESIGN (3) ──────────────────────────────────────────────────────────
  {
    id: 'wd-1',
    slug: 'de-ce-site-ul-tau-pierde-clienti',
    category: 'web-design',
    title: 'De ce site-ul tău pierde clienți și cum să remediezi asta în 2026',
    excerpt: 'Un site lent, nereactiv sau cu un design depășit poate costa o afacere mii de euro lunar. Descoperă cele mai frecvente greșeli și soluțiile dovedite.',
    content: `<h2>Viteza de încărcare — primul factor eliminatoriu</h2>
<p>Studiile Google arată că 53% dintre utilizatorii mobili abandonează un site care se încarcă mai mult de 3 secunde. Fiecare secundă în plus reduce conversiile cu aproximativ 7%. Un site cu imagini neoptimizate, scripturi blocante sau hosting slab poate pierde jumătate din traficul organic înainte ca utilizatorul să vadă măcar prima imagine. Soluția: optimizare imagini în format WebP, lazy loading, CDN și alegerea unui plan de hosting cu SSD NVMe și HTTP/3.</p>
<h2>Design neadaptat dispozitivelor mobile</h2>
<p>Peste 65% din traficul web global provine de pe dispozitive mobile în 2026. Un site care nu afișează corect pe telefon sau tabletă nu doar că frustrează utilizatorul — Google îl penalizează direct în clasamentele de căutare prin algoritmul Mobile-First Indexing.</p>
<ul><li>Implementați viewport meta tag corect</li><li>Folosiți CSS Grid și Flexbox în loc de tabele</li><li>Testați pe dispozitive reale, nu doar în simulatoare</li><li>Asigurați dimensiuni minime de 44px pentru zone tactile</li></ul>
<h2>Lipsa unui apel clar la acțiune (CTA)</h2>
<p>Vizitatorii nu trebuie să ghicească ce vreți să facă. Un site fără un CTA proeminent lasă utilizatorul confuz și îl împinge spre concurență. Testele A/B arată că un CTA bine poziționat poate crește conversiile cu 200–300%.</p>`,
    image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-04-10',
    updatedAt: '2026-04-10',
    seo: { title: 'De ce site-ul tău pierde clienți | Interpersonal IT', description: 'Află de ce site-ul tău pierde clienți și cum poți crește rata de conversie prin îmbunătățiri de UX, viteză și design în 2026.', keywords: 'site pierde clienti, conversii web, UX design, web design Romania', ogImage: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=1200&q=80' }
  },
  {
    id: 'wd-2',
    slug: 'tendinte-web-design-2026',
    category: 'web-design',
    title: 'Tendințe Web Design 2026: Ce adoptă companiile de top',
    excerpt: 'De la dark mode rafinat și micro-animații la AI-powered personalization, iată ce tendințe definesc designul web în 2026 și cum le poți aplica în afacerea ta.',
    content: `<h2>Dark Mode Rafinat și Glassmorphism</h2>
<p>Dark mode nu mai înseamnă simplu fundal negru cu text alb. Brandurile de top din 2026 folosesc tonuri adânci de albastru-negru cu accente luminoase, elemente semi-transparente (glassmorphism) și blur-uri subtile pentru a crea profunzime vizuală. Efectul nu este doar estetic — reduce oboseala ochilor și crește timpul petrecut pe site cu până la 35%.</p>
<h2>Micro-animații și Feedback Vizual</h2>
<p>Utilizatorii din 2026 așteaptă interfețe care „respiră" — elemente care răspund la hover, scroll și click cu animații subtile.</p>
<ul><li>Framer Motion pentru React — animații performante</li><li>CSS transitions sub 300ms pentru naturalețe</li><li>Respect pentru prefers-reduced-motion</li><li>Animații pe scroll cu Intersection Observer API</li></ul>
<h2>Personalizare Bazată pe AI</h2>
<p>Cel mai revoluționar trend din 2026 este personalizarea în timp real. Site-urile moderne adaptează conținutul, ofertele și chiar designul în funcție de comportamentul anterior al utilizatorului, locația geografică, ora din zi, dispozitivul folosit.</p>`,
    image: 'https://images.unsplash.com/photo-1545670723-196ed0954986?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-03-15',
    updatedAt: '2026-03-15',
    seo: { title: 'Tendințe Web Design 2026 | Interpersonal IT', description: 'Explorează tendințele de web design pentru 2026: dark mode, glassmorphism, animații subtile, AI personalization și design systems.', keywords: 'tendinte web design 2026, glassmorphism, dark mode, AI personalizare', ogImage: 'https://images.unsplash.com/photo-1545670723-196ed0954986?w=1200&q=80' }
  },
  {
    id: 'wd-3',
    slug: 'cat-costa-un-site-profesional-romania-2026',
    category: 'web-design',
    title: 'Cât costă un site profesional în România în 2026 — ghid complet de prețuri',
    excerpt: 'Transparență totală despre prețurile reale ale site-urilor web în România. De la site de prezentare la magazin online complex — ce include fiecare pachet.',
    content: `<h2>Site de Prezentare — de la 2.500 € + TVA</h2>
<p>Un site de prezentare profesional include: design personalizat (nu template generic), până la 10 pagini, optimizare SEO de bază, formular de contact funcțional, integrare Google Maps, certificat SSL, hosting 1 an, panoul de administrare pentru actualizare conținut și garanție 90 de zile. Prețul de 2.500 € reprezintă limita inferioară pentru calitate reală.</p>
<h2>Site Business Complex — de la 4.500 € + TVA</h2>
<p>Destinat companiilor cu nevoi de marketing online active: blog integrat, sistem de rezervări/programări, chat live, integrare CRM, multiple limbi, animații avansate.</p>
<ul><li>Design UI/UX custom, testat cu utilizatori reali</li><li>Optimizare Core Web Vitals (LCP, CLS, FID)</li><li>Integrare Google Analytics 4 + Search Console</li><li>Schema.org markup complet</li><li>GDPR compliance complet</li></ul>
<h2>E-Commerce — de la 7.500 € + TVA</h2>
<p>Un magazin online serios necesită investiție serioasă. La 7.500 €, Interpersonal livrează: platformă WooCommerce sau Shopify customizată, până la 500 de produse configurate, integrare procesator de plăți, gestionare stoc, notificări email automate.</p>`,
    image: 'https://images.unsplash.com/photo-1553484771-371a605b060b?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-02-20',
    updatedAt: '2026-02-20',
    seo: { title: 'Cât costă un site web în România 2026 — Prețuri reale | Interpersonal IT', description: 'Ghid complet de prețuri pentru site-uri web în România 2026: site prezentare, business, e-commerce. Ce include fiecare pachet.', keywords: 'pret site web Romania, cost website, web design pret 2026', ogImage: 'https://images.unsplash.com/photo-1553484771-371a605b060b?w=1200&q=80' }
  },

  // ── CALL CENTER (3) ─────────────────────────────────────────────────────────
  {
    id: 'cc-1',
    slug: 'cum-sa-reduci-timpul-de-asteptare-call-center',
    category: 'call-center',
    title: 'Cum să reduci timpul de așteptare în call center fără să angajezi mai mulți oameni',
    excerpt: 'Timpii mari de așteptare costă clienți și reputație. Descoperă strategii testate de optimizare a fluxului de apeluri care pot reduce AWT cu până la 60%.',
    content: `<h2>IVR Inteligent — Filtrarea Apelurilor la Sursă</h2>
<p>Sistemul IVR (Interactive Voice Response) configurat corect poate rezolva 30–40% din apeluri fără intervenție umană: soldul contului, status comandă, orarul de funcționare, adresa, întrebări frecvente. Secretul unui IVR eficient este arhitectura de meniu: maximum 3 niveluri, opțiunile cele mai frecvente pe primul loc, întotdeauna opțiunea de a vorbi cu un operator.</p>
<h2>Callback Automat — Clientul Nu Mai Stă La Coadă</h2>
<p>Sistemul de callback oferă apelantului opțiunea de a fi sunat înapoi când un agent devine disponibil, în loc să aștepte în coadă. Rezultate măsurate: rata de abandon scade cu 32%, satisfacția clientului crește cu 28%.</p>
<ul><li>Callback imediat (când un agent se eliberează)</li><li>Callback programat (clientul alege ora)</li><li>Callback la număr alternativ</li><li>Integrare automată cu CRM-ul</li></ul>
<h2>Skill-Based Routing și Real-Time Dashboard</h2>
<p>Rutarea bazată pe competențe direcționează apelul automat la agentul potrivit — cel specializat pe problema clientului. Efectul: First Call Resolution (FCR) crește cu 15–25%, handle time scade, satisfacția crește.</p>`,
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-04-05',
    updatedAt: '2026-04-05',
    seo: { title: 'Reducere timp așteptare call center | Interpersonal IT', description: 'Strategii practice pentru reducerea timpilor de așteptare în call center: IVR inteligent, callback, skill-based routing și analytics în timp real.', keywords: 'timp asteptare call center, IVR, callback automat, AWT reducere', ogImage: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80' }
  },
  {
    id: 'cc-2',
    slug: 'kpi-call-center-ce-masori-si-de-ce',
    category: 'call-center',
    title: 'KPI Call Center: Ce să măsori, cum să interpretezi și ce să faci cu datele',
    excerpt: 'Fără metrici corecți, un call center funcționează pe baza intuiției. Ghid practic al celor mai importanți indicatori de performanță.',
    content: `<h2>FCR (First Call Resolution) — Regele Metricilor</h2>
<p>First Call Resolution măsoară procentul de apeluri rezolvate din primul contact, fără a necesita un apel ulterior. Benchmark industrie: 70–75% este decent, 80%+ este excelent. Fiecare punct procentual în plus la FCR reduce costul operațional cu 1% și crește NPS-ul cu 1–2 puncte.</p>
<h2>AHT, CSAT și Abandonment Rate</h2>
<p>AHT (Average Handle Time): timp mediu per apel (conversație + after-call work). Benchmark: 4–6 minute pentru suport general. CSAT (Customer Satisfaction Score): satisfacția imediat post-apel, pe scală 1–5. Abandonment Rate: procentul de apeluri abandonate înainte de răspuns. Acceptabil: sub 5%.</p>
<ul><li>FCR > 75% = target minim</li><li>AHT = eficiență, nu viteză</li><li>CSAT > 4.0 = standard excelent</li><li>Abandonment Rate < 5% = sănătos</li></ul>
<h2>Cum Construiești un Dashboard de Management</h2>
<p>Un dashboard eficient are trei niveluri: timp real (coadă, agenți activi, apeluri în așteptare), zilnic (volum apeluri, distribuție ore, performanță pe agent) și lunar (tendințe KPI, comparație vs. target, analiză root-cause).</p>`,
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-03-01',
    updatedAt: '2026-03-01',
    seo: { title: 'KPI Call Center: FCR, AHT, CSAT, NPS — Ghid Complet | Interpersonal IT', description: 'Ghid complet KPI call center: FCR, AHT, CSAT, NPS, abandonment rate — ce înseamnă fiecare, cum se calculează și cum îmbunătățești performanța.', keywords: 'KPI call center, FCR, AHT, CSAT, NPS, metrici call center', ogImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80' }
  },
  {
    id: 'cc-3',
    slug: 'call-center-intern-vs-externalizat',
    category: 'call-center',
    title: 'Call Center Intern vs. Externalizat: Analiza completă pentru 2026',
    excerpt: 'Decizia de a construi un call center intern sau de a externaliza poate face diferența între profitabilitate și pierderi. Analiză cost-beneficiu cu date reale.',
    content: `<h2>Costurile Reale ale unui Call Center Intern</h2>
<p>Calculul complet al costului unui agent de call center intern (România, 2026): salariu brut 4.500–6.000 RON/lună, contribuții angajator ~34%, echipament (stație de lucru, headset, telefon IP) ~3.000–5.000 RON/agent, licențe software CRM ~50–150 EUR/agent/lună. Cost total per agent: 8.000–12.000 RON/lună. Pentru un call center de 10 agenți: 80.000–120.000 RON/lună.</p>
<h2>Avantajele și Dezavantajele Fiecărei Opțiuni</h2>
<ul><li>INTERN — Avantaje: control total, cunoaștere produs, cultura companiei</li><li>INTERN — Dezavantaje: costuri fixe ridicate, management HR complex, scalabilitate lentă</li><li>EXTERNALIZAT — Avantaje: costuri variabile, scalabilitate rapidă, expertiză specializată</li><li>EXTERNALIZAT — Dezavantaje: mai puțin control, risc de calitate</li></ul>
<h2>Recomandarea Interpersonal: Model Hibrid</h2>
<p>Pentru companiile cu 50–500 de angajați, modelul hibrid oferă cel mai bun raport calitate-preț: echipă internă mică (2–5 agenți) pentru clienții strategici și situații complexe, externalizare pentru volum, campanii sezoniere și suport în afara orelor normale.</p>`,
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-01-28',
    updatedAt: '2026-01-28',
    seo: { title: 'Call Center Intern vs Externalizat 2026 | Interpersonal IT', description: 'Analiză completă call center intern vs externalizat: costuri reale, avantaje, dezavantaje și recomandări pentru companii românești în 2026.', keywords: 'call center outsourcing, call center intern, externalizare call center, costuri', ogImage: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80' }
  },

  // ── IT HARDWARE (3) ─────────────────────────────────────────────────────────
  {
    id: 'hw-1',
    slug: 'cum-sa-alegi-serverul-potrivit-pentru-firma-ta',
    category: 'it-hardware',
    title: 'Cum să alegi serverul potrivit pentru firma ta în 2026 — ghid tehnic complet',
    excerpt: 'Server fizic, virtual sau cloud? Cum calculezi corect necesarul de performanță și cum eviți cheltuielile inutile. Ghid scris de ingineri IT.',
    content: `<h2>Server Fizic vs. VPS vs. Cloud — Când Alegi Ce</h2>
<p>Server fizic (on-premise): potrivit pentru companii cu >50 de utilizatori simultani, nevoi de latență ultra-redusă (sub 1ms), date sensibile care nu pot fi stocate în cloud. VPS (Virtual Private Server): ideal pentru site-uri web cu trafic mediu, aplicații business cu 10–50 utilizatori, backup centralizat. Cloud (AWS, Azure, GCP): perfect pentru nevoi variabile, startup-uri cu creștere impredictibilă.</p>
<h2>Specificații Minime Recomandate pe Tipuri de Utilizare</h2>
<ul><li>Office + ERP (20 utilizatori): CPU 8 core, RAM 32 GB ECC, SSD 1 TB RAID 1</li><li>Hosting web intern (100 site-uri): CPU 12 core, RAM 64 GB ECC, SSD 2 TB RAID 10</li><li>Baza de date critică: CPU 16+ core, RAM 128 GB ECC, SSD NVMe RAID 10</li><li>Virtualizare (50 VM-uri): CPU 32+ core, RAM 256 GB ECC, SSD 4 TB NVMe</li></ul>
<h2>Branduri Recomandate și Garanții</h2>
<p>Interpersonal lucrează cu Dell PowerEdge, HP ProLiant și Lenovo ThinkSystem. Toate serverele livrate includ: garanție on-site 3 ani (NBD — Next Business Day), management IPMI/iDRAC/iLO pentru acces la distanță, instalare și configurare inclusă.</p>`,
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-04-15',
    updatedAt: '2026-04-15',
    seo: { title: 'Cum alegi serverul potrivit pentru firma ta 2026 | Interpersonal IT', description: 'Ghid complet alegere server business Romania 2026: server fizic vs VPS vs cloud, specificații recomandate, branduri de top și costuri reale.', keywords: 'server business Romania, server fizic vs VPS, alegere server', ogImage: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&q=80' }
  },
  {
    id: 'hw-2',
    slug: 'reteaua-de-calculatoare-pentru-birou-ghid-2026',
    category: 'it-hardware',
    title: 'Rețeaua IT pentru birou: cum proiectezi o infrastructură sigură și scalabilă',
    excerpt: 'O rețea de birou prost proiectată costă în timp: securitate compromisă, downtime frecvent, performanță slabă. Ghid practic pentru infrastructura IT.',
    content: `<h2>Segmentarea Rețelei cu VLAN — Securitate și Performanță</h2>
<p>Cea mai importantă decizie în proiectarea unei rețele de birou: segmentarea în VLAN-uri (Virtual LAN). Rețea fără VLAN-uri = orice dispozitiv poate comunica cu orice alt dispozitiv — securitate zero. Segmentare minimă recomandată: VLAN Management, VLAN Date Angajați, VLAN VoIP, VLAN WiFi Oaspeți (izolat complet), VLAN Servere.</p>
<h2>Echipamente Recomandate pe Categorii</h2>
<ul><li>Router/Firewall: Fortinet FortiGate 60F sau pfSense pe hardware dedicat</li><li>Switch Core: Cisco Catalyst 9200 sau HPE Aruba 2930F (managed, PoE+)</li><li>Acces Points WiFi: Ubiquiti UniFi U6-Pro sau Cisco Meraki MR46</li><li>NAS pentru Backup: Synology DS1821+ cu 8 bay-uri</li><li>UPS: APC Smart-UPS 1500VA minim pentru echipamentele critice</li></ul>
<h2>VPN și Acces Remote Securizat</h2>
<p>Post-2020, accesul remote securizat a devenit o necesitate, nu un lux. Soluții recomandate de Interpersonal: WireGuard (performanță superioară, ideal pentru home office permanent), OpenVPN (compatibil larg, gratuit), Cisco AnyConnect (enterprise, cu autentificare MFA). Regulă absolută: nicio conexiune RDP direct pe Internet.</p>`,
    image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-03-10',
    updatedAt: '2026-03-10',
    seo: { title: 'Rețea IT birou: VLAN, WiFi enterprise, VPN — Ghid 2026 | Interpersonal IT', description: 'Ghid proiectare rețea IT birou 2026: switch-uri managed, WiFi enterprise, VLAN, firewall, VPN — soluții pentru companii mici și medii din România.', keywords: 'retea IT birou, VLAN, WiFi enterprise, firewall, VPN birou', ogImage: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=1200&q=80' }
  },
  {
    id: 'hw-3',
    slug: 'laptop-sau-desktop-pentru-angajati-comparatie',
    category: 'it-hardware',
    title: 'Laptop sau desktop pentru angajați? Ghid de achiziție pentru companii în 2026',
    excerpt: 'Alegerea greșită între laptop și desktop poate costa mii de euro în productivitate pierdută și înlocuiri premature. Ghid practic pentru fiecare tip de rol.',
    content: `<h2>Când Alegi Desktop vs. Laptop</h2>
<p>Desktop: ideal pentru posturi fixe (contabilitate, grafică, programare, call center), oferă performanță superioară la cost egal, mentenanță mai simplă și durată de viață mai lungă (5–7 ani vs. 3–5 ani laptop). Laptop: necesar pentru mobilitate (vânzări, management, consultanți). Regula practică Interpersonal: desktop pentru 70% din angajați, laptop pentru restul — reducere costuri 25–35% față de all-laptop.</p>
<h2>Specificații Recomandate pe Tipuri de Roluri</h2>
<ul><li>Birou basic (email, Office, ERP web): Intel i5/Ryzen 5, 16 GB RAM, SSD 256 GB</li><li>Contabilitate/ERP intensiv: Intel i7/Ryzen 7, 32 GB RAM, SSD 512 GB</li><li>Design grafic/Video: Intel i9/Ryzen 9, 64 GB RAM, SSD 1 TB NVMe, GPU dedicat</li><li>Programare/Dezvoltare: Intel i7/Ryzen 7, 32–64 GB RAM, SSD 1 TB NVMe</li><li>Call center: Intel i3/Ryzen 3, 8–16 GB RAM, SSD 256 GB</li></ul>
<h2>Branduri Recomandate și Politica de Achiziție</h2>
<p>Branduri cu cel mai bun raport calitate/preț/suport enterprise (România): Dell OptiPlex/Latitude, Lenovo ThinkPad/ThinkCentre, HP EliteBook/EliteDesk. Interpersonal recomandă achiziția în loturi (minim 5 unități pentru discount 10–15%), garanție extinsă on-site 3 ani.</p>`,
    image: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-02-05',
    updatedAt: '2026-02-05',
    seo: { title: 'Laptop sau Desktop pentru angajați — Ghid achiziție 2026 | Interpersonal IT', description: 'Ghid achiziție calculatoare corporative Romania 2026: laptop vs desktop, specificații recomandate per rol, branduri și prețuri reale pentru companii.', keywords: 'laptop vs desktop angajati, achizitii IT companii, calculatoare birou Romania', ogImage: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=1200&q=80' }
  },

  // ── HOSTING (3) ─────────────────────────────────────────────────────────────
  {
    id: 'host-1',
    slug: 'shared-hosting-vs-vps-vs-dedicat-comparatie-completa',
    category: 'hosting',
    title: 'Shared Hosting vs VPS vs Dedicat: Comparație completă pentru 2026',
    excerpt: 'Alegerea tipului greșit de hosting poate distruge performanța site-ului tău. Ghid tehnic cu exemple reale, prețuri și recomandări pe tipuri de afacere.',
    content: `<h2>Shared Hosting — Ieftin dar cu Limite Clare</h2>
<p>Shared hosting înseamnă că site-ul tău împarte resursele unui server cu zeci sau sute de alte site-uri. Avantaje: prețuri mici (de la 2–5 EUR/lună), configurare simplă. Dezavantaje majore: performanța depinde de vecinii tăi (efectul "vecin zgomotos"), resurse CPU și RAM limitate. Potrivit pentru: site-uri mici cu sub 1.000 vizitatori/zi.</p>
<h2>VPS — Echilibrul Perfect pentru IMM-uri</h2>
<p>VPS (Virtual Private Server) oferă resurse dedicate garantate pe un server fizic partajat, dar complet izolat. Interpersonal oferă planuri VPS de la 25 EUR/lună cu: 4 vCPU, 8 GB RAM, 100 GB SSD NVMe, 1 Gbps bandă, IP dedicat.</p>
<ul><li>Resurse garantate — nu te afectează alți clienți</li><li>Scalabilitate verticală rapidă (upgrade în &lt;30 minute)</li><li>Root access — instalezi orice ai nevoie</li><li>Snapshots și backup zilnic automat</li></ul>
<h2>Server Dedicat — Putere Maximă, Control Total</h2>
<p>Server dedicat înseamnă un server fizic exclusiv pentru tine: toate resursele, hardware select, configurare maximă. Necesar pentru: e-commerce cu >50.000 vizitatori/zi, aplicații enterprise cu >200 utilizatori simultani. Interpersonal oferă servere dedicate de la 150 EUR/lună cu SLA 99.95% garantat.</p>`,
    image: 'https://images.unsplash.com/photo-1614624532983-4ce03382d63d?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-04-18',
    updatedAt: '2026-04-18',
    seo: { title: 'Shared Hosting vs VPS vs Dedicat — Comparație 2026 | Interpersonal IT', description: 'Comparație completă shared hosting vs VPS vs server dedicat: performanță, prețuri, securitate și recomandări pentru site-uri românești în 2026.', keywords: 'shared hosting vs VPS, server dedicat, hosting comparatie, gazduire web', ogImage: 'https://images.unsplash.com/photo-1614624532983-4ce03382d63d?w=1200&q=80' }
  },
  {
    id: 'host-2',
    slug: 'securitatea-site-ului-web-ghid-complet-2026',
    category: 'hosting',
    title: 'Securitatea site-ului web: 10 pași esențiali pentru 2026',
    excerpt: 'În 2026, un site nesecurizat nu este doar un risc tehnic — este o răspundere legală sub GDPR. Ghid complet de securitate web pentru antreprenori.',
    content: `<h2>Pașii 1–4: Fundația Securității</h2>
<ul><li>1. SSL/TLS certificat valid (HTTPS obligatoriu) — Google penalizează site-urile HTTP</li><li>2. Update-uri automate pentru CMS, plugin-uri și teme — 70% din hackuri exploatează vulnerabilități cunoscute</li><li>3. Backup automat zilnic cu retenție 30 de zile și testare periodică a restaurării</li><li>4. Parolă admin puternică (16+ caractere, alfanumerice + simboluri) + autentificare în doi pași (2FA)</li></ul>
<h2>Pașii 5–8: Protecție Activă</h2>
<ul><li>5. WAF (Web Application Firewall): Cloudflare Pro sau Sucuri — blochează automat atacurile OWASP Top 10</li><li>6. Rate limiting și protecție brute-force pentru pagina de login</li><li>7. Scanare automată malware (Wordfence, Malcare) — alertă email imediată la detectare</li><li>8. Schimbare URL admin implicit (/wp-admin → /panou-secret-xxxxx)</li></ul>
<h2>Pașii 9–10: Conformitate GDPR și Monitorizare</h2>
<p>Pasul 9 — Conformitate GDPR: Notificare de securitate obligatorie în 72 de ore la ANSPDCP în caz de breach. Politica de confidențialitate actualizată. Cookie consent conform Directivei ePrivacy. Pasul 10 — Monitorizare continuă: uptime monitoring, Google Search Console, audit de securitate anual.</p>`,
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-03-20',
    updatedAt: '2026-03-20',
    seo: { title: 'Securitatea site-ului web: 10 pași esențiali 2026 | Interpersonal IT', description: 'Ghid securitate site web 2026: SSL, WAF, backup, autentificare 2FA, GDPR compliance — 10 pași esențiali pentru protejarea site-ului și clienților tăi.', keywords: 'securitate site web, SSL certificat, WAF, backup site, GDPR securitate', ogImage: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1200&q=80' }
  },
  {
    id: 'host-3',
    slug: 'migrare-hosting-fara-downtime-ghid-pas-cu-pas',
    category: 'hosting',
    title: 'Migrare Hosting Fără Downtime: Ghid Pas-cu-Pas pentru 2026',
    excerpt: 'Schimbarea furnizorului de hosting nu trebuie să îți închidă site-ul. Procedura corectă de migrare care garantează 0 minute de downtime și 0 pierderi de date.',
    content: `<h2>Etapa 1–3: Pregătire și Copiere</h2>
<ul><li>1. Backup complet pe hosting actual: fișiere + baza de date + email-uri (IMAP local)</li><li>2. Creați contul pe noul hosting și configurați domenii, certificate SSL, PHP versiune identică</li><li>3. Copiați fișierele via FTP/SFTP și importați baza de date pe noul hosting</li></ul>
<h2>Etapa 4–5: Testare Înainte de DNS Switch</h2>
<p>Cel mai important pas, omis frecvent: testați site-ul pe noul hosting ÎNAINTE de a schimba DNS-ul. Metodă: editați fișierul hosts pe calculatorul vostru pentru a pointa domeniul la noul IP. Verificați: toate paginile, formularele, procesatorul de plăți, conturile email, viteza de încărcare.</p>
<h2>Etapa 6: DNS Switch și Monitorizare Post-Migrare</h2>
<p>Reduceți TTL-ul DNS la 300 secunde (5 minute) cu 24 de ore înainte de switch. Schimbați nameserver-ele sau A record-ul la noul IP. Monitorizați propagarea DNS (dnschecker.org) — propagare completă în 2–48 de ore. Interpersonal execută migrări hosting gratuit pentru toți clienții care trec pe planurile noastre de hosting premium.</p>`,
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-01-15',
    updatedAt: '2026-01-15',
    seo: { title: 'Migrare Hosting Fără Downtime — Ghid Complet 2026 | Interpersonal IT', description: 'Ghid complet migrare hosting fără downtime 2026: backup, copiere fișiere, migrare baza de date, propagare DNS — procedura pas-cu-pas.', keywords: 'migrare hosting fara downtime, schimbare hosting, DNS propagare, migrare site', ogImage: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80' }
  },

  // ── VOIP (3) ────────────────────────────────────────────────────────────────
  {
    id: 'voip-1',
    slug: 'voip-vs-telefonie-traditionala-comparatie-2026',
    category: 'voip',
    title: 'VoIP vs. Telefonie Tradițională: De ce 78% din companii au migrat deja',
    excerpt: 'Telefonia IP nu mai este o opțiune futuristă — este standardul de facto în 2026. Comparație completă de costuri, funcționalități și scalabilitate.',
    content: `<h2>Economii Reale: Cât Costă Telefonia în 2026</h2>
<p>Telefonie tradițională (PSTN/ISDN): linie telefonică fixă ~50–80 RON/lună/linie, apeluri naționale 0.04–0.08 RON/minut, apeluri internaționale 0.25–1.50 RON/minut, centrală telefonică fizică 5.000–50.000 RON investiție. VoIP: abonament SIP trunk de la 15 EUR/lună pentru 10 canale simultane, apeluri naționale 0.005–0.015 EUR/minut. Economii medii la migrare VoIP: 40–65% din costul lunar de telecomunicații.</p>
<h2>Funcționalități Exclusive VoIP</h2>
<ul><li>Softphone: apeluri de pe laptop/mobil, oriunde în lume, cu același număr de firmă</li><li>Auto-attendant: meniu vocal automat 24/7 fără operator uman</li><li>Call recording: înregistrare automată apeluri (conformitate GDPR cu consimțământ)</li><li>Video conferință HD integrată — nu mai e nevoie de Zoom separat</li><li>CRM integration: fișa clientului se deschide automat la apel primit</li></ul>
<h2>Migrarea la VoIP — Pașii Corecți</h2>
<p>Migrarea de la telefonia tradițională la VoIP nu presupune nicio întrerupere dacă se face corect: audit al infrastructurii de rețea existente, portare numere existente (durată 3–15 zile lucrătoare), configurare centrală VoIP în cloud, instalare telefoane IP sau softphone-uri, training echipă 2–4 ore. Interpersonal execută migrări VoIP complete în 5–10 zile lucrătoare.</p>`,
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-04-12',
    updatedAt: '2026-04-12',
    seo: { title: 'VoIP vs Telefonie Tradițională — Comparație 2026 | Interpersonal IT', description: 'Comparație completă VoIP vs telefonie tradițională 2026: economii reale, funcționalități avansate, integrare CRM și ghid de migrare pentru companii românești.', keywords: 'VoIP vs PSTN, migrare VoIP, economii telefonie, SIP trunk Romania', ogImage: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200&q=80' }
  },
  {
    id: 'voip-2',
    slug: 'centrala-voip-asterisk-pentru-sme',
    category: 'voip',
    title: 'Centrala VoIP Asterisk/FreePBX pentru IMM: ghid de implementare 2026',
    excerpt: 'Asterisk/FreePBX este cea mai flexibilă soluție de telefonie VoIP open-source pentru companii. Ghid tehnic de implementare, funcționalități cheie și cazuri reale.',
    content: `<h2>De Ce Asterisk/FreePBX și Nu Soluție Comercială</h2>
<p>Asterisk este motorul VoIP open-source care rulează sub FreePBX (interfată grafică). Avantajele față de soluțiile comerciale (3CX, Cisco, Avaya): zero licențe recurente, control total al configurației, integrare cu orice sistem extern prin API, comunitate vastă de suport. Dezavantajul principal: necesită expertiză pentru implementare și mentenanță.</p>
<h2>Funcționalitățile Cheie pentru Companii</h2>
<ul><li>IVR multi-nivel cu text-to-speech în română</li><li>Cozi de așteptare cu muzică, mesaje și statistici</li><li>Ring groups (mai mulți agenți sună simultan)</li><li>Voicemail cu trimitere automată pe email (audio + transcript)</li><li>Conferință audio cu PIN de acces</li><li>CDR (Call Detail Records) — rapoarte complete de telefonie</li><li>Integrare SIP trunk cu orice provider (Telnyx, Twilio, furnizori locali)</li><li>Fail-over automat la provider secundar</li></ul>
<h2>Studiu de Caz: Companie de 50 Angajați, Economie de 68%</h2>
<p>Un client Interpersonal din sectorul serviciilor financiare cu 50 de angajați a migrat de la o centrală Panasonic + linii ISDN la Asterisk/FreePBX + SIP trunk în 2025. Rezultate după 6 luni: cost lunar telefonie -68% (de la 4.200 RON la 1.350 RON), FCR call center +23%, timp mediu de răspuns -31%. ROI complet al implementării: 4 luni.</p>`,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-03-05',
    updatedAt: '2026-03-05',
    seo: { title: 'Centrala VoIP Asterisk/FreePBX pentru IMM 2026 | Interpersonal IT', description: 'Ghid implementare centrala VoIP Asterisk FreePBX pentru IMM Romania 2026: arhitectura, funcționalități, costuri și studiu de caz real.', keywords: 'Asterisk FreePBX implementare, centrala VoIP IMM, VoIP open source Romania', ogImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=80' }
  },
  {
    id: 'voip-3',
    slug: 'voip-in-telemunca-ghid-complet',
    category: 'voip',
    title: 'VoIP și Telemuncă: Cum îți păstrezi numărul de firmă oriunde în lume',
    excerpt: 'Cu VoIP, angajații tăi pot lucra din orice locație cu acces la internet, folosind același număr de firmă, cu aceleași funcționalități ca la birou.',
    content: `<h2>Softphone — Biroul în Laptop sau Telefon</h2>
<p>Un softphone este aplicația care transformă laptopul sau telefonul mobil într-un telefon de birou complet. Funcționează identic cu un telefon IP fizic: același număr intern și extern, acces la transfer, conferință, hold, voicemail. Opțiuni recomandate: Zoiper (gratuita, multi-platformă), Linphone (open-source), MizuPhone (Windows). Pentru telefon mobil: Acrobits Groundwire (iOS/Android). Configurare: server SIP, cont, parolă — 5 minute.</p>
<h2>Cerințe de Rețea pentru Calitate VoIP Optimă</h2>
<ul><li>Lățime de bandă minimă: 100 Kbps upload + download per apel activ</li><li>Latență: sub 150ms (ideal sub 50ms)</li><li>Jitter: sub 30ms pentru calitate optimă</li><li>Packet loss: sub 1% — orice pierdere de pachete degradează vocea</li><li>QoS (Quality of Service): prioritizarea traficului VoIP în router-ul de acasă</li></ul>
<h2>Securitate VoIP pentru Telemuncă</h2>
<p>VoIP peste internet deschis = risc de interceptare și abuz (toll fraud). Soluții obligatorii: SRTP pentru criptarea vocii în tranzit, TLS pentru criptarea semnalizării SIP, autentificare puternică cont SIP (parolă 20+ caractere), fail2ban pe serverul Asterisk, VPN pentru conexiunile din afara țării.</p>`,
    image: 'https://images.unsplash.com/photo-1587614382346-4ec70e388b28?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-02-10',
    updatedAt: '2026-02-10',
    seo: { title: 'VoIP și Telemuncă — Ghid Complet 2026 | Interpersonal IT', description: 'Ghid complet VoIP pentru telemuncă 2026: softphone, aplicații mobile, configurare securizată, calitate audio și soluții recomandate pentru lucrul de acasă.', keywords: 'VoIP telemunca, softphone home office, VoIP securitate, lucru de acasa telefonie', ogImage: 'https://images.unsplash.com/photo-1587614382346-4ec70e388b28?w=1200&q=80' }
  },

  // ── CRM SOFTWARE (3) ────────────────────────────────────────────────────────
  {
    id: 'crm-1',
    slug: 'ce-este-crm-si-de-ce-ai-nevoie-de-el',
    category: 'crm-software',
    title: 'Ce este un CRM și de ce fiecare afacere cu >5 clienți are nevoie de unul',
    excerpt: 'Excel-ul nu mai este suficient. Descoperă cum un CRM transformă haosul relațiilor cu clienții în procese clare, vânzări mai mari și clienți mai fideli.',
    content: `<h2>CRM — Mai Mult Decât o Bază de Date</h2>
<p>CRM (Customer Relationship Management) este sistemul care centralizează toate informațiile despre clienți și interacțiunile cu aceștia: date contact, istoricul achizițiilor, conversații, oferte trimise, statusul pipeline-ului de vânzări, sarcini și follow-up-uri. Diferența față de Excel: automatizare (follow-up-uri trimise automat), vizibilitate (ce face fiecare agent în timp real), analitics (prognoza vânzărilor). Statistic: companiile care folosesc CRM cresc vânzările cu 29% și productivitatea echipei de vânzări cu 34% (Salesforce, 2025).</p>
<h2>Semnele că ai Nevoie Urgent de un CRM</h2>
<ul><li>Pierzi lead-uri pentru că nimeni nu a dat follow-up la timp</li><li>Când un angajat pleacă, pleacă și relațiile cu clienții din capul lui</li><li>Nu știi câte oferte aveți deschise sau ce valoare au</li><li>Clienții se plâng că le explicați de 3 ori aceleași lucruri</li><li>Rapoartele de vânzări durează ore de compilat manual</li><li>Nu poți prognoza cu acuratețe veniturile lunii viitoare</li></ul>
<h2>Alegerea CRM-ului Potrivit: Framework de Decizie</h2>
<p>Criteri de selecție CRM pentru companii românești: numărul de utilizatori (1–10 utilizatori: Pipedrive, HubSpot Free; 10–50: HubSpot Starter, Zoho CRM; 50+: Salesforce, Microsoft Dynamics sau CRM custom), integrări necesare (telefonie VoIP, email marketing, ERP, site web), buget (SaaS: 15–150 EUR/utilizator/lună; on-premise custom: 10.000–50.000 EUR investiție). Interpersonal dezvoltă CRM-uri custom și integrează soluții existente cu sistemele tale.</p>`,
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-04-20',
    updatedAt: '2026-04-20',
    seo: { title: 'Ce este un CRM și de ce ai nevoie de el | Interpersonal IT', description: 'Ghid complet CRM pentru companii românești: ce este un CRM, beneficii reale, comparatie solutii populare si cum alegi CRM-ul potrivit pentru afacerea ta.', keywords: 'ce este CRM, software CRM Romania, beneficii CRM, alegere CRM', ogImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80' }
  },
  {
    id: 'crm-2',
    slug: 'automatizarea-vanzarilor-cu-crm-ghid-practic',
    category: 'crm-software',
    title: 'Automatizarea Vânzărilor cu CRM: Ghid Practic pentru Companii Românești',
    excerpt: 'Automatizarea nu înlocuiește vânzătorii — îi eliberează de sarcinile repetitive și le permite să se concentreze pe ce contează: construirea relațiilor și închiderea contractelor.',
    content: `<h2>Cele 5 Automatizări cu cel mai Mare Impact</h2>
<ul><li>1. Lead assignment automat: lead nou → verificare sursă → alocare la agentul potrivit → notificare instant</li><li>2. Email welcome sequence: client nou → serie de 5 emailuri în 14 zile cu informații utile despre servicii</li><li>3. Follow-up automat: ofertă trimisă → 3 zile fără răspuns → email automat de reminder → 7 zile → apel programat</li><li>4. Pipeline stage alerts: contract stagnat >7 zile în aceeași etapă → alertă manager pe Slack/email</li><li>5. Renewal reminders: contract expiră în 90 zile → start workflow reînnoire automată</li></ul>
<h2>Lead Scoring — Prioritizarea Automată a Lead-urilor</h2>
<p>Lead scoring atribuie puncte automat fiecărui lead în funcție de comportament: a vizitat pagina de prețuri (+10 puncte), a deschis 3+ emailuri (+15 puncte), a completat formularul de contact (+25 puncte), este manager/director în titlu LinkedIn (+20 puncte). Lead cu scor >70: urmărit urgent de senior sales. Lead 30–70: nurturing automat. Sub 30: campanie email generală.</p>
<h2>Integrări Esențiale CRM pentru Piața Românească</h2>
<p>Interpersonal integrează CRM-urile cu: facturare (SmartBill, Facturis — creare factură automată la câștigarea contractului), telefonie VoIP (fișa client se deschide automat la apel, conversațiile sunt înregistrate și atașate), email marketing (Mailchimp, ActiveCampaign — sincronizare liste automat), site web (formularele de contact generează lead-uri direct în CRM). Fiecare integrare economisește în medie 2–4 ore/agent/săptămână.</p>`,
    image: 'https://images.unsplash.com/photo-1553028826-f4804a6dba3b?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-03-12',
    updatedAt: '2026-03-12',
    seo: { title: 'Automatizarea Vânzărilor cu CRM — Ghid Practic | Interpersonal IT', description: 'Ghid automatizare vânzări cu CRM 2026: workflow-uri automate, email sequences, lead scoring, notificări și integrări pentru companii românești.', keywords: 'automatizare vanzari CRM, lead scoring, email sequences, workflow CRM', ogImage: 'https://images.unsplash.com/photo-1553028826-f4804a6dba3b?w=1200&q=80' }
  },
  {
    id: 'crm-3',
    slug: 'crm-custom-vs-saas-ce-alegem-pentru-romania',
    category: 'crm-software',
    title: 'CRM Custom vs. SaaS (Salesforce, HubSpot): Ce alegem pentru companiile românești',
    excerpt: 'Soluțiile SaaS sunt convenabile, dar nu se potrivesc mereu cu procesele specifice ale businessului tău. Analiză completă: când merită un CRM custom și când nu.',
    content: `<h2>CRM SaaS — Avantaje și Limitări</h2>
<p>Soluțiile SaaS (HubSpot, Pipedrive, Salesforce) au revoluționat piața CRM: implementare în zile, actualizări automate, zero mentenanță tehnică, scalabilitate instantă. Costul: 20–150 EUR/utilizator/lună = pentru o echipă de 20 de persoane, 4.800–36.000 EUR/an. Limitările principale: personalizare limitată la ce permite platforma, datele sunt stocate pe servere externe (implicații GDPR!), dependența de furnizor (vendor lock-in).</p>
<h2>CRM Custom — Când Justifică Investiția</h2>
<p>Un CRM custom devine mai eficient economic față de SaaS când: echipa depășește 30 de utilizatori (costul SaaS devine prohibitiv), procesele de business sunt foarte specifice și nu se potrivesc în template-urile SaaS, datele clienților sunt sensibile și trebuie să rămână on-premise.</p>
<ul><li>Proprietatea completă a datelor și codului sursă</li><li>Zero costuri lunare recurente de licențe</li><li>Integrare perfectă cu orice sistem intern</li><li>Scalabilitate fără costuri suplimentare per utilizator</li><li>Conformitate GDPR garantată cu stocare locală</li></ul>
<h2>Recomandarea Interpersonal pe Dimensiunea Companiei</h2>
<p>Sub 10 utilizatori → HubSpot Free sau Pipedrive (14–25 EUR/user/lună). 10–30 utilizatori → HubSpot Starter/Professional sau Zoho CRM. 30–50 utilizatori → Evaluare comparativă: CRM custom poate fi mai ieftin pe termen de 3 ani. Peste 50 utilizatori → CRM custom sau Salesforce Enterprise, cu analiză ROI detaliată. Interpersonal oferă consultanță gratuită pentru alegerea soluției CRM.</p>`,
    image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=1200&q=80',
    author: 'Interpersonal IT',
    status: 'published',
    createdAt: '2026-01-20',
    updatedAt: '2026-01-20',
    seo: { title: 'CRM Custom vs SaaS — Ce alegem pentru România? | Interpersonal IT', description: 'Comparatie CRM custom vs SaaS pentru companii romanesti 2026: costuri reale, avantaje, dezavantaje si recomandari pe dimensiunea companiei.', keywords: 'CRM custom vs SaaS, Salesforce vs custom CRM, HubSpot alternativa, CRM Romania', ogImage: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=1200&q=80' }
  },
];

/* ── Default Products ─────────────────────────────────────────────────────── */
export const defaultProducts: Product[] = [
  {
    "id": "pc-01",
    "name": "Apple iMac 24\" M4 8-core 24GB 1TB",
    "slug": "pc-01-apple-imac-24-m4-8-core-24gb-1tb",
    "brand": "Apple",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 7437.02,
    "priceTva": 8998.79,
    "currency": "RON",
    "period": "once",
    "description": "Apple — Apple iMac 24\" M4 8-core 24GB 1TB. Produs IT profesional disponibil în stoc.",
    "features": [
      "Procesor Apple M4 8-core",
      "RAM 24GB Unified Memory",
      "SSD 1TB NVMe",
      "Display Retina 4.5K 24\""
    ],
    "specs": [
      "Procesor Apple M4 8-core",
      "RAM 24GB Unified Memory",
      "SSD 1TB NVMe",
      "Display Retina 4.5K 24\""
    ],
    "badge": "Premium",
    "image": "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/imac-24-blue-selection-202310?wid=904&hei=840&fmt=jpeg&qlt=90",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Apple iMac 24\" M4 8-core 24GB 1TB — Interpersonal IT",
      "description": "Cumpără Apple iMac 24\" M4 8-core 24GB 1TB la prețul de 8998.79 RON cu TVA. Apple disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Apple, Apple iMac 24\" M4 8-core 24GB 1TB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Apple Distribution Int. / iStyle Romania",
    "purchasePrice": 6197.52,
    "salePrice": 7437.02,
    "salePriceTva": 8998.79,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-02",
    "name": "Lenovo IdeaCentre AIO 3 27\" i7 16GB 1TB",
    "slug": "pc-02-lenovo-ideacentre-aio-3-27-i7-16gb-1tb",
    "brand": "Lenovo",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 3271.74,
    "priceTva": 3958.81,
    "currency": "RON",
    "period": "once",
    "description": "Lenovo — Lenovo IdeaCentre AIO 3 27\" i7 16GB 1TB. Produs IT profesional disponibil în stoc.",
    "features": [
      "Intel Core i7-13620H",
      "RAM 16GB DDR4",
      "SSD 512GB + HDD 1TB",
      "Display 27\" FHD IPS"
    ],
    "specs": [
      "Intel Core i7-13620H",
      "RAM 16GB DDR4",
      "SSD 512GB + HDD 1TB",
      "Display 27\" FHD IPS"
    ],
    "badge": "Popular",
    "image": "https://p1-ofp.static.pub/fes/cms/2023/05/31/cjxg3qihn9c2w2jl1fxyzf2mcetxwn613684.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Lenovo IdeaCentre AIO 3 27\" i7 16GB 1TB — Interpersonal IT",
      "description": "Cumpără Lenovo IdeaCentre AIO 3 27\" i7 16GB 1TB la prețul de 3958.81 RON cu TVA. Lenovo disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Lenovo, Lenovo IdeaCentre AIO 3 27\" i7 16GB 1TB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Lenovo Romania / eMAG Business",
    "purchasePrice": 2726.45,
    "salePrice": 3271.74,
    "salePriceTva": 3958.81,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-03",
    "name": "Apple Mac Mini M4 16GB 512GB",
    "slug": "pc-03-apple-mac-mini-m4-16gb-512gb",
    "brand": "Apple",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 3470.09,
    "priceTva": 4198.81,
    "currency": "RON",
    "period": "once",
    "description": "Apple — Apple Mac Mini M4 16GB 512GB. Produs IT profesional disponibil în stoc.",
    "features": [
      "Procesor Apple M4 10-core",
      "RAM 16GB Unified Memory",
      "SSD 512GB NVMe",
      "USB-C Thunderbolt 4"
    ],
    "specs": [
      "Procesor Apple M4 10-core",
      "RAM 16GB Unified Memory",
      "SSD 512GB NVMe",
      "USB-C Thunderbolt 4"
    ],
    "badge": "Nou",
    "image": "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/mac-mini-hero-202410?wid=904&hei=840&fmt=jpeg&qlt=90",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Apple Mac Mini M4 16GB 512GB — Interpersonal IT",
      "description": "Cumpără Apple Mac Mini M4 16GB 512GB la prețul de 4198.81 RON cu TVA. Apple disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Apple, Apple Mac Mini M4 16GB 512GB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Apple Distribution Int. / iStyle Romania",
    "purchasePrice": 2891.74,
    "salePrice": 3470.09,
    "salePriceTva": 4198.81,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-04",
    "name": "HP Pro Tower 400 G9 i7-13700 32GB 1TB",
    "slug": "pc-04-hp-pro-tower-400-g9-i7-13700-32gb-1tb",
    "brand": "HP",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 4858.51,
    "priceTva": 5878.8,
    "currency": "RON",
    "period": "once",
    "description": "HP — HP Pro Tower 400 G9 i7-13700 32GB 1TB. Produs IT profesional disponibil în stoc.",
    "features": [
      "Intel Core i7-13700",
      "RAM 32GB DDR4",
      "SSD 1TB NVMe",
      "Windows 11 Pro"
    ],
    "specs": [
      "Intel Core i7-13700",
      "RAM 32GB DDR4",
      "SSD 1TB NVMe",
      "Windows 11 Pro"
    ],
    "badge": "Business",
    "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/knowledgebase/c08105617.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "HP Pro Tower 400 G9 i7-13700 32GB 1TB — Interpersonal IT",
      "description": "Cumpără HP Pro Tower 400 G9 i7-13700 32GB 1TB la prețul de 5878.8 RON cu TVA. HP disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "HP, HP Pro Tower 400 G9 i7-13700 32GB 1TB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "HP Inc. Romania",
    "purchasePrice": 4048.76,
    "salePrice": 4858.51,
    "salePriceTva": 5878.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-05",
    "name": "Dell OptiPlex 7010 i5-13500 16GB 512GB",
    "slug": "pc-05-dell-optiplex-7010-i5-13500-16gb-512gb",
    "brand": "Dell",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 2875.04,
    "priceTva": 3478.8,
    "currency": "RON",
    "period": "once",
    "description": "Dell — Dell OptiPlex 7010 i5-13500 16GB 512GB. Produs IT profesional disponibil în stoc.",
    "features": [
      "Intel Core i5-13500",
      "RAM 16GB DDR4",
      "SSD 512GB NVMe",
      "Factor forma SFF"
    ],
    "specs": [
      "Intel Core i5-13500",
      "RAM 16GB DDR4",
      "SSD 512GB NVMe",
      "Factor forma SFF"
    ],
    "badge": null,
    "image": "https://i.dell.com/is/image/DellContent/content/dam/ss2/product-images/dell-client-products/desktops/optiplex-desktops/7010/media-gallery/desktop-optiplex-7010-nt-blue-gallery-4.psd",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Dell OptiPlex 7010 i5-13500 16GB 512GB — Interpersonal IT",
      "description": "Cumpără Dell OptiPlex 7010 i5-13500 16GB 512GB la prețul de 3478.8 RON cu TVA. Dell disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Dell, Dell OptiPlex 7010 i5-13500 16GB 512GB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Dell Technologies Romania",
    "purchasePrice": 2395.87,
    "salePrice": 2875.04,
    "salePriceTva": 3478.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-06",
    "name": "VIST PC i7-14700KF RTX 4080 32GB 1TB",
    "slug": "pc-06-vist-pc-i7-14700kf-rtx-4080-32gb-1tb",
    "brand": "VIST",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 9916.37,
    "priceTva": 11998.81,
    "currency": "RON",
    "period": "once",
    "description": "VIST — VIST PC i7-14700KF RTX 4080 32GB 1TB. Produs IT profesional disponibil în stoc.",
    "features": [
      "Intel Core i7-14700KF",
      "NVIDIA RTX 4080 16GB",
      "RAM 32GB DDR5",
      "SSD 1TB M.2 PCIe 4.0"
    ],
    "specs": [
      "Intel Core i7-14700KF",
      "NVIDIA RTX 4080 16GB",
      "RAM 32GB DDR5",
      "SSD 1TB M.2 PCIe 4.0"
    ],
    "badge": "Gaming",
    "image": "https://m.media-amazon.com/images/I/61LlXajRmYL._AC_UF894,1000_QL80_.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "VIST PC i7-14700KF RTX 4080 32GB 1TB — Interpersonal IT",
      "description": "Cumpără VIST PC i7-14700KF RTX 4080 32GB 1TB la prețul de 11998.81 RON cu TVA. VIST disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "VIST, VIST PC i7-14700KF RTX 4080 32GB 1TB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "PC Garage Romania",
    "purchasePrice": 8263.64,
    "salePrice": 9916.37,
    "salePriceTva": 11998.81,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-07",
    "name": "Lenovo ThinkStation P3 Ultra i9-13900 64GB",
    "slug": "pc-07-lenovo-thinkstation-p3-ultra-i9-13900-64gb",
    "brand": "Lenovo",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 12395.7,
    "priceTva": 14998.8,
    "currency": "RON",
    "period": "once",
    "description": "Lenovo — Lenovo ThinkStation P3 Ultra i9-13900 64GB. Produs IT profesional disponibil în stoc.",
    "features": [
      "Intel Core i9-13900",
      "RAM 64GB ECC DDR5",
      "SSD 2TB NVMe",
      "NVIDIA RTX A2000"
    ],
    "specs": [
      "Intel Core i9-13900",
      "RAM 64GB ECC DDR5",
      "SSD 2TB NVMe",
      "NVIDIA RTX A2000"
    ],
    "badge": "Workstation",
    "image": "https://p4-ofp.static.pub//fes/cms/2023/01/12/87lmmfcpghq3w3c2mphg9nmqs57o4s093836.png",
    "highlighted": false,
    "status": "active",
    "inStock": false,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Lenovo ThinkStation P3 Ultra i9-13900 64GB — Interpersonal IT",
      "description": "Cumpără Lenovo ThinkStation P3 Ultra i9-13900 64GB la prețul de 14998.8 RON cu TVA. Lenovo disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Lenovo, Lenovo ThinkStation P3 Ultra i9-13900 64GB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Lenovo Romania / eMAG Business",
    "purchasePrice": 10329.75,
    "salePrice": 12395.7,
    "salePriceTva": 14998.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-08",
    "name": "HP EliteDesk 800 G9 i9-13900 32GB 1TB",
    "slug": "pc-08-hp-elitedesk-800-g9-i9-13900-32gb-1tb",
    "brand": "HP",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 6445.28,
    "priceTva": 7798.79,
    "currency": "RON",
    "period": "once",
    "description": "HP — HP EliteDesk 800 G9 i9-13900 32GB 1TB. Produs IT profesional disponibil în stoc.",
    "features": [
      "Intel Core i9-13900",
      "RAM 32GB DDR5",
      "SSD 1TB PCIe 4.0",
      "Windows 11 Pro"
    ],
    "specs": [
      "Intel Core i9-13900",
      "RAM 32GB DDR5",
      "SSD 1TB PCIe 4.0",
      "Windows 11 Pro"
    ],
    "badge": "Business",
    "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/knowledgebase/c08100516.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "HP EliteDesk 800 G9 i9-13900 32GB 1TB — Interpersonal IT",
      "description": "Cumpără HP EliteDesk 800 G9 i9-13900 32GB 1TB la prețul de 7798.79 RON cu TVA. HP disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "HP, HP EliteDesk 800 G9 i9-13900 32GB 1TB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "HP Inc. Romania",
    "purchasePrice": 5371.07,
    "salePrice": 6445.28,
    "salePriceTva": 7798.79,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-09",
    "name": "Dell XPS Desktop 8960 i7-13700K RTX 4060",
    "slug": "pc-09-dell-xps-desktop-8960-i7-13700k-rtx-4060",
    "brand": "Dell",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 5255.21,
    "priceTva": 6358.8,
    "currency": "RON",
    "period": "once",
    "description": "Dell — Dell XPS Desktop 8960 i7-13700K RTX 4060. Produs IT profesional disponibil în stoc.",
    "features": [
      "Intel Core i7-13700K",
      "NVIDIA RTX 4060 8GB",
      "RAM 32GB DDR5",
      "SSD 1TB PCIe 4.0"
    ],
    "specs": [
      "Intel Core i7-13700K",
      "NVIDIA RTX 4060 8GB",
      "RAM 32GB DDR5",
      "SSD 1TB PCIe 4.0"
    ],
    "badge": null,
    "image": "https://i.dell.com/is/image/DellContent/content/dam/ss2/product-images/dell-client-products/desktops/xps-desktops/xps-8960/media-gallery/desktop-xps-8960-gallery-3.psd",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Dell XPS Desktop 8960 i7-13700K RTX 4060 — Interpersonal IT",
      "description": "Cumpără Dell XPS Desktop 8960 i7-13700K RTX 4060 la prețul de 6358.8 RON cu TVA. Dell disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Dell, Dell XPS Desktop 8960 i7-13700K RTX 4060, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Dell Technologies Romania",
    "purchasePrice": 4379.34,
    "salePrice": 5255.21,
    "salePriceTva": 6358.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "pc-10",
    "name": "MSI PRO DP180 Ryzen 7 7745HX 32GB 1TB",
    "slug": "pc-10-msi-pro-dp180-ryzen-7-7745hx-32gb-1tb",
    "brand": "MSI",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "sisteme-pc",
    "subcategoryLabel": "Sisteme PC",
    "price": 3767.6,
    "priceTva": 4558.8,
    "currency": "RON",
    "period": "once",
    "description": "MSI — MSI PRO DP180 Ryzen 7 7745HX 32GB 1TB. Produs IT profesional disponibil în stoc.",
    "features": [
      "AMD Ryzen 7 7745HX",
      "RAM 32GB DDR5",
      "SSD 1TB NVMe",
      "GeForce RTX 4060 8GB"
    ],
    "specs": [
      "AMD Ryzen 7 7745HX",
      "RAM 32GB DDR5",
      "SSD 1TB NVMe",
      "GeForce RTX 4060 8GB"
    ],
    "badge": null,
    "image": "https://asset.msi.com/resize/image/global/product/product_1693397380b4a45a8fbd07a45dca64706c7ab07987.png62405b38c58fe0f07fcef2367d8a9ba1/1024.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "MSI PRO DP180 Ryzen 7 7745HX 32GB 1TB — Interpersonal IT",
      "description": "Cumpără MSI PRO DP180 Ryzen 7 7745HX 32GB 1TB la prețul de 4558.8 RON cu TVA. MSI disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "MSI, MSI PRO DP180 Ryzen 7 7745HX 32GB 1TB, Sisteme PC, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "MSI Romania / PC Garage",
    "purchasePrice": 3139.67,
    "salePrice": 3767.6,
    "salePriceTva": 4558.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-01",
    "name": "ASUS RT-AX58U AX3000 Wi-Fi 6 Router",
    "slug": "net-01-asus-rt-ax58u-ax3000-wi-fi-6-router",
    "brand": "ASUS",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 484.96,
    "priceTva": 586.8,
    "currency": "RON",
    "period": "once",
    "description": "ASUS — ASUS RT-AX58U AX3000 Wi-Fi 6 Router. Produs IT profesional disponibil în stoc.",
    "features": [
      "Wi-Fi 6 AX3000",
      "4x LAN Gigabit",
      "Processor 1.8GHz dual-core",
      "MU-MIMO, OFDMA"
    ],
    "specs": [
      "Wi-Fi 6 AX3000",
      "4x LAN Gigabit",
      "Processor 1.8GHz dual-core",
      "MU-MIMO, OFDMA"
    ],
    "badge": null,
    "image": "https://dlcdnets.asus.com/pub/ASUS/wireless/RT-AX58U/RT-AX58U_clean.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "ASUS RT-AX58U AX3000 Wi-Fi 6 Router — Interpersonal IT",
      "description": "Cumpără ASUS RT-AX58U AX3000 Wi-Fi 6 Router la prețul de 586.8 RON cu TVA. ASUS disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "ASUS, ASUS RT-AX58U AX3000 Wi-Fi 6 Router, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "ASUS Romania / eMAG",
    "purchasePrice": 404.13,
    "salePrice": 484.96,
    "salePriceTva": 586.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-02",
    "name": "TP-Link Archer AX55 AX3000 Wi-Fi 6",
    "slug": "net-02-tp-link-archer-ax55-ax3000-wi-fi-6",
    "brand": "TP-Link",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 327.28,
    "priceTva": 396.01,
    "currency": "RON",
    "period": "once",
    "description": "TP-Link — TP-Link Archer AX55 AX3000 Wi-Fi 6. Produs IT profesional disponibil în stoc.",
    "features": [
      "Wi-Fi 6 AX3000",
      "5 porturi Gigabit",
      "USB 3.0",
      "OneMesh compatible"
    ],
    "specs": [
      "Wi-Fi 6 AX3000",
      "5 porturi Gigabit",
      "USB 3.0",
      "OneMesh compatible"
    ],
    "badge": null,
    "image": "https://static.tp-link.com/upload/product-overview/2020/202012/20201201/20201201_151313_Archer%20AX55(EU)_overview_normalsize.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "TP-Link Archer AX55 AX3000 Wi-Fi 6 — Interpersonal IT",
      "description": "Cumpără TP-Link Archer AX55 AX3000 Wi-Fi 6 la prețul de 396.01 RON cu TVA. TP-Link disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "TP-Link, TP-Link Archer AX55 AX3000 Wi-Fi 6, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "TP-Link Romania / eMAG",
    "purchasePrice": 272.73,
    "salePrice": 327.28,
    "salePriceTva": 396.01,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-03",
    "name": "Ubiquiti UniFi 6 Pro Access Point",
    "slug": "net-03-ubiquiti-unifi-6-pro-access-point",
    "brand": "Ubiquiti",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 797.35,
    "priceTva": 964.79,
    "currency": "RON",
    "period": "once",
    "description": "Ubiquiti — Ubiquiti UniFi 6 Pro Access Point. Produs IT profesional disponibil în stoc.",
    "features": [
      "Wi-Fi 6 4x4 MU-MIMO",
      "Dual-band 2.4/5GHz",
      "PoE IEEE 802.3at",
      "Max 300 clienți simultan"
    ],
    "specs": [
      "Wi-Fi 6 4x4 MU-MIMO",
      "Dual-band 2.4/5GHz",
      "PoE IEEE 802.3at",
      "Max 300 clienți simultan"
    ],
    "badge": "Pro",
    "image": "https://dl.ui.com/qig/U6-Pro/images/product-hero.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Ubiquiti UniFi 6 Pro Access Point — Interpersonal IT",
      "description": "Cumpără Ubiquiti UniFi 6 Pro Access Point la prețul de 964.79 RON cu TVA. Ubiquiti disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Ubiquiti, Ubiquiti UniFi 6 Pro Access Point, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Altex Professional / eMAG",
    "purchasePrice": 664.46,
    "salePrice": 797.35,
    "salePriceTva": 964.79,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-04",
    "name": "Cisco CBS110-16T Switch 16-port Gigabit",
    "slug": "net-04-cisco-cbs110-16t-switch-16-port-gigabit",
    "brand": "Cisco",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 224.14,
    "priceTva": 271.21,
    "currency": "RON",
    "period": "once",
    "description": "Cisco — Cisco CBS110-16T Switch 16-port Gigabit. Produs IT profesional disponibil în stoc.",
    "features": [
      "16 porturi Gigabit",
      "Fără management",
      "Plug-and-play",
      "Desktop/rack"
    ],
    "specs": [
      "16 porturi Gigabit",
      "Fără management",
      "Plug-and-play",
      "Desktop/rack"
    ],
    "badge": null,
    "image": "https://www.cisco.com/c/dam/en/us/products/collateral/switches/business-110-series-unmanaged-switches/nb-06-bus110-ser-unm-sw-cte-en.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Cisco CBS110-16T Switch 16-port Gigabit — Interpersonal IT",
      "description": "Cumpără Cisco CBS110-16T Switch 16-port Gigabit la prețul de 271.21 RON cu TVA. Cisco disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Cisco, Cisco CBS110-16T Switch 16-port Gigabit, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Cisco Systems Romania",
    "purchasePrice": 186.78,
    "salePrice": 224.14,
    "salePriceTva": 271.21,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-05",
    "name": "TP-Link Deco X50 Mesh Wi-Fi 6 3-Pack",
    "slug": "net-05-tp-link-deco-x50-mesh-wi-fi-6-3-pack",
    "brand": "TP-Link",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 841.98,
    "priceTva": 1018.8,
    "currency": "RON",
    "period": "once",
    "description": "TP-Link — TP-Link Deco X50 Mesh Wi-Fi 6 3-Pack. Produs IT profesional disponibil în stoc.",
    "features": [
      "Wi-Fi 6 AX3000",
      "Mesh 3-pack",
      "Acoperire 650 mp",
      "PoE pass-through"
    ],
    "specs": [
      "Wi-Fi 6 AX3000",
      "Mesh 3-pack",
      "Acoperire 650 mp",
      "PoE pass-through"
    ],
    "badge": null,
    "image": "https://static.tp-link.com/upload/product-overview/2021/202104/20210427/20210427_165540_Deco%20X50(3-pack)_overview_normalsize.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "TP-Link Deco X50 Mesh Wi-Fi 6 3-Pack — Interpersonal IT",
      "description": "Cumpără TP-Link Deco X50 Mesh Wi-Fi 6 3-Pack la prețul de 1018.8 RON cu TVA. TP-Link disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "TP-Link, TP-Link Deco X50 Mesh Wi-Fi 6 3-Pack, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "TP-Link Romania / eMAG",
    "purchasePrice": 701.65,
    "salePrice": 841.98,
    "salePriceTva": 1018.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-06",
    "name": "MikroTik RB4011iGS+RM Router",
    "slug": "net-06-mikrotik-rb4011igsrm-router",
    "brand": "MikroTik",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 792.4,
    "priceTva": 958.8,
    "currency": "RON",
    "period": "once",
    "description": "MikroTik — MikroTik RB4011iGS+RM Router. Produs IT profesional disponibil în stoc.",
    "features": [
      "1.4GHz quad-core CPU",
      "10x Gigabit LAN",
      "1x SFP+ 10Gbps",
      "RouterOS L5"
    ],
    "specs": [
      "1.4GHz quad-core CPU",
      "10x Gigabit LAN",
      "1x SFP+ 10Gbps",
      "RouterOS L5"
    ],
    "badge": null,
    "image": "https://i.mt.lv/cdn/product_photos/a5e9f91a03f8a09cff7cb5d68ec4ea54.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "MikroTik RB4011iGS+RM Router — Interpersonal IT",
      "description": "Cumpără MikroTik RB4011iGS+RM Router la prețul de 958.8 RON cu TVA. MikroTik disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "MikroTik, MikroTik RB4011iGS+RM Router, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "MikroTik / IT&C Partners",
    "purchasePrice": 660.33,
    "salePrice": 792.4,
    "salePriceTva": 958.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-07",
    "name": "Ubiquiti EdgeSwitch ES-16-XG 10GbE",
    "slug": "net-07-ubiquiti-edgeswitch-es-16-xg-10gbe",
    "brand": "Ubiquiti",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 1734.54,
    "priceTva": 2098.79,
    "currency": "RON",
    "period": "once",
    "description": "Ubiquiti — Ubiquiti EdgeSwitch ES-16-XG 10GbE. Produs IT profesional disponibil în stoc.",
    "features": [
      "16 porturi 10GbE SFP+",
      "Managed Layer 2",
      "PoE budget 150W",
      "Rack 1U"
    ],
    "specs": [
      "16 porturi 10GbE SFP+",
      "Managed Layer 2",
      "PoE budget 150W",
      "Rack 1U"
    ],
    "badge": "Enterprise",
    "image": "https://dl.ui.com/qig/ES-16-XG/images/product-hero.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Ubiquiti EdgeSwitch ES-16-XG 10GbE — Interpersonal IT",
      "description": "Cumpără Ubiquiti EdgeSwitch ES-16-XG 10GbE la prețul de 2098.79 RON cu TVA. Ubiquiti disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Ubiquiti, Ubiquiti EdgeSwitch ES-16-XG 10GbE, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Altex Professional / eMAG",
    "purchasePrice": 1445.45,
    "salePrice": 1734.54,
    "salePriceTva": 2098.79,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-08",
    "name": "Fortinet FortiGate 40F Firewall UTM",
    "slug": "net-08-fortinet-fortigate-40f-firewall-utm",
    "brand": "Fortinet",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 1387.44,
    "priceTva": 1678.8,
    "currency": "RON",
    "period": "once",
    "description": "Fortinet — Fortinet FortiGate 40F Firewall UTM. Produs IT profesional disponibil în stoc.",
    "features": [
      "UTM Firewall 5Gbps",
      "IPS, AV, Web Filter",
      "SSL-VPN 100 tunele",
      "FortiOS"
    ],
    "specs": [
      "UTM Firewall 5Gbps",
      "IPS, AV, Web Filter",
      "SSL-VPN 100 tunele",
      "FortiOS"
    ],
    "badge": "Securitate",
    "image": "https://www.fortinet.com/content/dam/fortinet/images/products/medium-enterprise-firewalls/FG-40F.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Fortinet FortiGate 40F Firewall UTM — Interpersonal IT",
      "description": "Cumpără Fortinet FortiGate 40F Firewall UTM la prețul de 1678.8 RON cu TVA. Fortinet disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Fortinet, Fortinet FortiGate 40F Firewall UTM, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Fortinet Romania (Ingram Micro)",
    "purchasePrice": 1156.2,
    "salePrice": 1387.44,
    "salePriceTva": 1678.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-09",
    "name": "TP-Link TL-SF1024 Switch 24-port Fast Ethernet",
    "slug": "net-09-tp-link-tl-sf1024-switch-24-port-fast-ethernet",
    "brand": "TP-Link",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 147.77,
    "priceTva": 178.8,
    "currency": "RON",
    "period": "once",
    "description": "TP-Link — TP-Link TL-SF1024 Switch 24-port Fast Ethernet. Produs IT profesional disponibil în stoc.",
    "features": [
      "24 porturi 10/100Mbps",
      "Rackmount 19\"",
      "Plug-and-play",
      "Fără ventilator"
    ],
    "specs": [
      "24 porturi 10/100Mbps",
      "Rackmount 19\"",
      "Plug-and-play",
      "Fără ventilator"
    ],
    "badge": null,
    "image": "https://static.tp-link.com/TL-SF1024_V7_1596597888264a.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "TP-Link TL-SF1024 Switch 24-port Fast Ethernet — Interpersonal IT",
      "description": "Cumpără TP-Link TL-SF1024 Switch 24-port Fast Ethernet la prețul de 178.8 RON cu TVA. TP-Link disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "TP-Link, TP-Link TL-SF1024 Switch 24-port Fast Ethernet, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "TP-Link Romania / eMAG",
    "purchasePrice": 123.14,
    "salePrice": 147.77,
    "salePriceTva": 178.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "net-10",
    "name": "Synology RT6600ax Wi-Fi 6 Router Quad-Band",
    "slug": "net-10-synology-rt6600ax-wi-fi-6-router-quad-band",
    "brand": "Synology",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "retelistica",
    "subcategoryLabel": "Rețelistică",
    "price": 1089.91,
    "priceTva": 1318.79,
    "currency": "RON",
    "period": "once",
    "description": "Synology — Synology RT6600ax Wi-Fi 6 Router Quad-Band. Produs IT profesional disponibil în stoc.",
    "features": [
      "Wi-Fi 6 Quad-band",
      "SRM OS management",
      "VPN Server integrat",
      "4 porturi Gigabit WAN/LAN"
    ],
    "specs": [
      "Wi-Fi 6 Quad-band",
      "SRM OS management",
      "VPN Server integrat",
      "4 porturi Gigabit WAN/LAN"
    ],
    "badge": null,
    "image": "https://global.synologycdn.com/fly/products/synology/img/products/RT6600ax/img/2022_03_SYNOLOGY_RT6600ax_hero.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Synology RT6600ax Wi-Fi 6 Router Quad-Band — Interpersonal IT",
      "description": "Cumpără Synology RT6600ax Wi-Fi 6 Router Quad-Band la prețul de 1318.79 RON cu TVA. Synology disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Synology, Synology RT6600ax Wi-Fi 6 Router Quad-Band, Rețelistică, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Synology Romania / eMAG",
    "purchasePrice": 908.26,
    "salePrice": 1089.91,
    "salePriceTva": 1318.79,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-01",
    "name": "HP LaserJet M110w Laser Monocrom A4",
    "slug": "imp-01-hp-laserjet-m110w-laser-monocrom-a4",
    "brand": "HP",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 446.28,
    "priceTva": 540.0,
    "currency": "RON",
    "period": "once",
    "description": "HP — HP LaserJet M110w Laser Monocrom A4. Produs IT profesional disponibil în stoc.",
    "features": [
      "Laser monocrom A4",
      "Wireless Wi-Fi",
      "Viteză 21 ppm",
      "USB 2.0"
    ],
    "specs": [
      "Laser monocrom A4",
      "Wireless Wi-Fi",
      "Viteză 21 ppm",
      "USB 2.0"
    ],
    "badge": null,
    "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/knowledgebase/c08353684.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "HP LaserJet M110w Laser Monocrom A4 — Interpersonal IT",
      "description": "Cumpără HP LaserJet M110w Laser Monocrom A4 la prețul de 540.0 RON cu TVA. HP disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "HP, HP LaserJet M110w Laser Monocrom A4, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "HP Inc. Romania",
    "purchasePrice": 371.9,
    "salePrice": 446.28,
    "salePriceTva": 540.0,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-02",
    "name": "Canon PIXMA G3430 CISS Inkjet Color",
    "slug": "imp-02-canon-pixma-g3430-ciss-inkjet-color",
    "brand": "Canon",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 634.72,
    "priceTva": 768.01,
    "currency": "RON",
    "period": "once",
    "description": "Canon — Canon PIXMA G3430 CISS Inkjet Color. Produs IT profesional disponibil în stoc.",
    "features": [
      "Inkjet color CISS",
      "Wi-Fi, USB",
      "Copiere, scanare",
      "Rezervoare reîncărcabile"
    ],
    "specs": [
      "Inkjet color CISS",
      "Wi-Fi, USB",
      "Copiere, scanare",
      "Rezervoare reîncărcabile"
    ],
    "badge": null,
    "image": "https://www.canon.ro/media/g3430_tcm14-2026580.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Canon PIXMA G3430 CISS Inkjet Color — Interpersonal IT",
      "description": "Cumpără Canon PIXMA G3430 CISS Inkjet Color la prețul de 768.01 RON cu TVA. Canon disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Canon, Canon PIXMA G3430 CISS Inkjet Color, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Canon Romania",
    "purchasePrice": 528.93,
    "salePrice": 634.72,
    "salePriceTva": 768.01,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-03",
    "name": "Epson EcoTank L3280 Inkjet Color Wi-Fi",
    "slug": "imp-03-epson-ecotank-l3280-inkjet-color-wi-fi",
    "brand": "Epson",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 892.56,
    "priceTva": 1080.0,
    "currency": "RON",
    "period": "once",
    "description": "Epson — Epson EcoTank L3280 Inkjet Color Wi-Fi. Produs IT profesional disponibil în stoc.",
    "features": [
      "Inkjet color rezervoare mari",
      "Wi-Fi direct",
      "Print/copy/scan",
      "Durată 7500 pagini BN"
    ],
    "specs": [
      "Inkjet color rezervoare mari",
      "Wi-Fi direct",
      "Print/copy/scan",
      "Durată 7500 pagini BN"
    ],
    "badge": null,
    "image": "https://www.epson.ro/fileadmin/content/products/small_format_inkjet/consumer_inkjet/EcoTank_L3280/L3280-front_320x320.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Epson EcoTank L3280 Inkjet Color Wi-Fi — Interpersonal IT",
      "description": "Cumpără Epson EcoTank L3280 Inkjet Color Wi-Fi la prețul de 1080.0 RON cu TVA. Epson disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Epson, Epson EcoTank L3280 Inkjet Color Wi-Fi, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Epson Europe BV Romania",
    "purchasePrice": 743.8,
    "salePrice": 892.56,
    "salePriceTva": 1080.0,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-04",
    "name": "Brother HL-L2442DW Laser Duplex Wi-Fi",
    "slug": "imp-04-brother-hl-l2442dw-laser-duplex-wi-fi",
    "brand": "Brother",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 632.72,
    "priceTva": 765.59,
    "currency": "RON",
    "period": "once",
    "description": "Brother — Brother HL-L2442DW Laser Duplex Wi-Fi. Produs IT profesional disponibil în stoc.",
    "features": [
      "Laser monocrom duplex",
      "Wi-Fi, Ethernet",
      "34 ppm",
      "Toner starter 700 pag"
    ],
    "specs": [
      "Laser monocrom duplex",
      "Wi-Fi, Ethernet",
      "34 ppm",
      "Toner starter 700 pag"
    ],
    "badge": null,
    "image": "https://download.brother.com/welcome/docp100618/HL-L2442DW.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Brother HL-L2442DW Laser Duplex Wi-Fi — Interpersonal IT",
      "description": "Cumpără Brother HL-L2442DW Laser Duplex Wi-Fi la prețul de 765.59 RON cu TVA. Brother disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Brother, Brother HL-L2442DW Laser Duplex Wi-Fi, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Brother Industries Romania",
    "purchasePrice": 527.27,
    "salePrice": 632.72,
    "salePriceTva": 765.59,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-05",
    "name": "HP LaserJet MFP M234dw Laser Rețea",
    "slug": "imp-05-hp-laserjet-mfp-m234dw-laser-retea",
    "brand": "HP",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 604.96,
    "priceTva": 732.0,
    "currency": "RON",
    "period": "once",
    "description": "HP — HP LaserJet MFP M234dw Laser Rețea. Produs IT profesional disponibil în stoc.",
    "features": [
      "Laser MFP monocrom",
      "Wi-Fi, Ethernet, USB",
      "Print/copy/scan/fax",
      "30 ppm A4"
    ],
    "specs": [
      "Laser MFP monocrom",
      "Wi-Fi, Ethernet, USB",
      "Print/copy/scan/fax",
      "30 ppm A4"
    ],
    "badge": null,
    "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/knowledgebase/c08244649.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "HP LaserJet MFP M234dw Laser Rețea — Interpersonal IT",
      "description": "Cumpără HP LaserJet MFP M234dw Laser Rețea la prețul de 732.0 RON cu TVA. HP disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "HP, HP LaserJet MFP M234dw Laser Rețea, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "HP Inc. Romania",
    "purchasePrice": 504.13,
    "salePrice": 604.96,
    "salePriceTva": 732.0,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-06",
    "name": "Xerox WorkCentre 3025NI MFP Laser Wi-Fi",
    "slug": "imp-06-xerox-workcentre-3025ni-mfp-laser-wi-fi",
    "brand": "Xerox",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 743.8,
    "priceTva": 900.0,
    "currency": "RON",
    "period": "once",
    "description": "Xerox — Xerox WorkCentre 3025NI MFP Laser Wi-Fi. Produs IT profesional disponibil în stoc.",
    "features": [
      "Laser MFP monocrom A4",
      "Wi-Fi, Ethernet",
      "Print/copy/scan/fax",
      "20 ppm"
    ],
    "specs": [
      "Laser MFP monocrom A4",
      "Wi-Fi, Ethernet",
      "Print/copy/scan/fax",
      "20 ppm"
    ],
    "badge": null,
    "image": "https://www.xerox.com/en-us/assets/2021/09/14/WorkCentre-3025.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Xerox WorkCentre 3025NI MFP Laser Wi-Fi — Interpersonal IT",
      "description": "Cumpără Xerox WorkCentre 3025NI MFP Laser Wi-Fi la prețul de 900.0 RON cu TVA. Xerox disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Xerox, Xerox WorkCentre 3025NI MFP Laser Wi-Fi, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Xerox Romania",
    "purchasePrice": 619.83,
    "salePrice": 743.8,
    "salePriceTva": 900.0,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-07",
    "name": "Epson EcoTank L5310 CISS Rețea Wi-Fi",
    "slug": "imp-07-epson-ecotank-l5310-ciss-retea-wi-fi",
    "brand": "Epson",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 1209.91,
    "priceTva": 1463.99,
    "currency": "RON",
    "period": "once",
    "description": "Epson — Epson EcoTank L5310 CISS Rețea Wi-Fi. Produs IT profesional disponibil în stoc.",
    "features": [
      "Inkjet color CISS",
      "Wi-Fi, Ethernet",
      "Print/copy/scan/fax",
      "Durată 6000 pagini culoare"
    ],
    "specs": [
      "Inkjet color CISS",
      "Wi-Fi, Ethernet",
      "Print/copy/scan/fax",
      "Durată 6000 pagini culoare"
    ],
    "badge": null,
    "image": "https://www.epson.ro/fileadmin/content/products/small_format_inkjet/consumer_inkjet/EcoTank_L5310/L5310_front_320x320.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Epson EcoTank L5310 CISS Rețea Wi-Fi — Interpersonal IT",
      "description": "Cumpără Epson EcoTank L5310 CISS Rețea Wi-Fi la prețul de 1463.99 RON cu TVA. Epson disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Epson, Epson EcoTank L5310 CISS Rețea Wi-Fi, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Epson Europe BV Romania",
    "purchasePrice": 1008.26,
    "salePrice": 1209.91,
    "salePriceTva": 1463.99,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-08",
    "name": "Brother MFC-L2802DW Laser Fax Wi-Fi A4",
    "slug": "imp-08-brother-mfc-l2802dw-laser-fax-wi-fi-a4",
    "brand": "Brother",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 952.07,
    "priceTva": 1152.0,
    "currency": "RON",
    "period": "once",
    "description": "Brother — Brother MFC-L2802DW Laser Fax Wi-Fi A4. Produs IT profesional disponibil în stoc.",
    "features": [
      "Laser MFP monocrom A4",
      "Wi-Fi, Ethernet",
      "Print/copy/scan/fax",
      "Duplex automat"
    ],
    "specs": [
      "Laser MFP monocrom A4",
      "Wi-Fi, Ethernet",
      "Print/copy/scan/fax",
      "Duplex automat"
    ],
    "badge": null,
    "image": "https://download.brother.com/welcome/docp100619/MFC-L2802DW.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Brother MFC-L2802DW Laser Fax Wi-Fi A4 — Interpersonal IT",
      "description": "Cumpără Brother MFC-L2802DW Laser Fax Wi-Fi A4 la prețul de 1152.0 RON cu TVA. Brother disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Brother, Brother MFC-L2802DW Laser Fax Wi-Fi A4, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Brother Industries Romania",
    "purchasePrice": 793.39,
    "salePrice": 952.07,
    "salePriceTva": 1152.0,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-09",
    "name": "Brother DCP-L3520CDW Laser Color Duplex",
    "slug": "imp-09-brother-dcp-l3520cdw-laser-color-duplex",
    "brand": "Brother",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 1684.96,
    "priceTva": 2038.8,
    "currency": "RON",
    "period": "once",
    "description": "Brother — Brother DCP-L3520CDW Laser Color Duplex. Produs IT profesional disponibil în stoc.",
    "features": [
      "Laser color MFP A4",
      "Wi-Fi, Ethernet",
      "Duplex automat",
      "18 ppm color"
    ],
    "specs": [
      "Laser color MFP A4",
      "Wi-Fi, Ethernet",
      "Duplex automat",
      "18 ppm color"
    ],
    "badge": null,
    "image": "https://download.brother.com/welcome/docp100620/DCP-L3520CDW.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Brother DCP-L3520CDW Laser Color Duplex — Interpersonal IT",
      "description": "Cumpără Brother DCP-L3520CDW Laser Color Duplex la prețul de 2038.8 RON cu TVA. Brother disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Brother, Brother DCP-L3520CDW Laser Color Duplex, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Brother Industries Romania",
    "purchasePrice": 1404.13,
    "salePrice": 1684.96,
    "salePriceTva": 2038.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "imp-10",
    "name": "HP Smart Tank 582 AiO Wi-Fi Apple AirPrint",
    "slug": "imp-10-hp-smart-tank-582-aio-wi-fi-apple-airprint",
    "brand": "HP",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "imprimante",
    "subcategoryLabel": "Imprimante",
    "price": 694.21,
    "priceTva": 839.99,
    "currency": "RON",
    "period": "once",
    "description": "HP — HP Smart Tank 582 AiO Wi-Fi Apple AirPrint. Produs IT profesional disponibil în stoc.",
    "features": [
      "Inkjet color rezervoare",
      "Wi-Fi, USB",
      "AirPrint, Mopria",
      "Print/copy/scan"
    ],
    "specs": [
      "Inkjet color rezervoare",
      "Wi-Fi, USB",
      "AirPrint, Mopria",
      "Print/copy/scan"
    ],
    "badge": null,
    "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/knowledgebase/c08283479.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "HP Smart Tank 582 AiO Wi-Fi Apple AirPrint — Interpersonal IT",
      "description": "Cumpără HP Smart Tank 582 AiO Wi-Fi Apple AirPrint la prețul de 839.99 RON cu TVA. HP disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "HP, HP Smart Tank 582 AiO Wi-Fi Apple AirPrint, Imprimante, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "HP Inc. Romania",
    "purchasePrice": 578.51,
    "salePrice": 694.21,
    "salePriceTva": 839.99,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-01",
    "name": "AMD Ryzen 7 7800X3D 5.0GHz AM5 Box",
    "slug": "comp-01-amd-ryzen-7-7800x3d-50ghz-am5-box",
    "brand": "AMD",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 1734.54,
    "priceTva": 2098.79,
    "currency": "RON",
    "period": "once",
    "description": "AMD — AMD Ryzen 7 7800X3D 5.0GHz AM5 Box. Produs IT profesional disponibil în stoc.",
    "features": [
      "8 core / 16 thread",
      "5.0GHz Boost",
      "96MB L3 Cache 3D V-Cache",
      "Socket AM5, TDP 120W"
    ],
    "specs": [
      "8 core / 16 thread",
      "5.0GHz Boost",
      "96MB L3 Cache 3D V-Cache",
      "Socket AM5, TDP 120W"
    ],
    "badge": "Gaming",
    "image": "https://cdn.amd.com/System/Product%20Resources/17/17-001/02_7800x3d_pib.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "AMD Ryzen 7 7800X3D 5.0GHz AM5 Box — Interpersonal IT",
      "description": "Cumpără AMD Ryzen 7 7800X3D 5.0GHz AM5 Box la prețul de 2098.79 RON cu TVA. AMD disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "AMD, AMD Ryzen 7 7800X3D 5.0GHz AM5 Box, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "AMD Romania / eMAG Business",
    "purchasePrice": 1445.45,
    "salePrice": 1734.54,
    "salePriceTva": 2098.79,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-02",
    "name": "Intel Core i5-14600K 5.3GHz LGA1700 Box",
    "slug": "comp-02-intel-core-i5-14600k-53ghz-lga1700-box",
    "brand": "Intel",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 1575.86,
    "priceTva": 1906.79,
    "currency": "RON",
    "period": "once",
    "description": "Intel — Intel Core i5-14600K 5.3GHz LGA1700 Box. Produs IT profesional disponibil în stoc.",
    "features": [
      "14 core (6P+8E)",
      "5.3GHz Boost",
      "24MB L3 Cache",
      "Socket LGA1700, TDP 125W"
    ],
    "specs": [
      "14 core (6P+8E)",
      "5.3GHz Boost",
      "24MB L3 Cache",
      "Socket LGA1700, TDP 125W"
    ],
    "badge": null,
    "image": "https://www.intel.com/content/dam/www/public/us/en/images/boxed-chip-photos/nn-14600k-boxshot-800x600.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Intel Core i5-14600K 5.3GHz LGA1700 Box — Interpersonal IT",
      "description": "Cumpără Intel Core i5-14600K 5.3GHz LGA1700 Box la prețul de 1906.79 RON cu TVA. Intel disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Intel, Intel Core i5-14600K 5.3GHz LGA1700 Box, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Intel Corporation / eMAG Business",
    "purchasePrice": 1313.22,
    "salePrice": 1575.86,
    "salePriceTva": 1906.79,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-03",
    "name": "NVIDIA RTX 4070 SUPER 12GB GDDR6X",
    "slug": "comp-03-nvidia-rtx-4070-super-12gb-gddr6x",
    "brand": "NVIDIA",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 3272.72,
    "priceTva": 3959.99,
    "currency": "RON",
    "period": "once",
    "description": "NVIDIA — NVIDIA RTX 4070 SUPER 12GB GDDR6X. Produs IT profesional disponibil în stoc.",
    "features": [
      "12GB GDDR6X",
      "DLSS 3.0, Ray Tracing",
      "PCIe 4.0 x16",
      "200W TDP"
    ],
    "specs": [
      "12GB GDDR6X",
      "DLSS 3.0, Ray Tracing",
      "PCIe 4.0 x16",
      "200W TDP"
    ],
    "badge": "Recomandat",
    "image": "https://www.nvidia.com/content/dam/en-zz/Solutions/geforce/ada/rtx-4070-super/geforce-rtx-4070-super-front-630.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "NVIDIA RTX 4070 SUPER 12GB GDDR6X — Interpersonal IT",
      "description": "Cumpără NVIDIA RTX 4070 SUPER 12GB GDDR6X la prețul de 3959.99 RON cu TVA. NVIDIA disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "NVIDIA, NVIDIA RTX 4070 SUPER 12GB GDDR6X, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "ASUS Romania / PC Garage",
    "purchasePrice": 2727.27,
    "salePrice": 3272.72,
    "salePriceTva": 3959.99,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-04",
    "name": "Samsung 990 Pro 2TB M.2 NVMe PCIe 4.0",
    "slug": "comp-04-samsung-990-pro-2tb-m2-nvme-pcie-40",
    "brand": "Samsung",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 1080.0,
    "priceTva": 1306.8,
    "currency": "RON",
    "period": "once",
    "description": "Samsung — Samsung 990 Pro 2TB M.2 NVMe PCIe 4.0. Produs IT profesional disponibil în stoc.",
    "features": [
      "2TB M.2 NVMe PCIe 4.0",
      "Citire 7450 MB/s",
      "Scriere 6900 MB/s",
      "DRAM cache inclus"
    ],
    "specs": [
      "2TB M.2 NVMe PCIe 4.0",
      "Citire 7450 MB/s",
      "Scriere 6900 MB/s",
      "DRAM cache inclus"
    ],
    "badge": null,
    "image": "https://image-us.samsung.com/SamsungUS/home/computing/memory-storage/solid-state-drives/02252022/990-Pro.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Samsung 990 Pro 2TB M.2 NVMe PCIe 4.0 — Interpersonal IT",
      "description": "Cumpără Samsung 990 Pro 2TB M.2 NVMe PCIe 4.0 la prețul de 1306.8 RON cu TVA. Samsung disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Samsung, Samsung 990 Pro 2TB M.2 NVMe PCIe 4.0, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Samsung Electronics Romania",
    "purchasePrice": 900.0,
    "salePrice": 1080.0,
    "salePriceTva": 1306.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-05",
    "name": "Corsair Vengeance 32GB DDR5 6000MHz CL30",
    "slug": "comp-05-corsair-vengeance-32gb-ddr5-6000mhz-cl30",
    "brand": "Corsair",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 594.05,
    "priceTva": 718.8,
    "currency": "RON",
    "period": "once",
    "description": "Corsair — Corsair Vengeance 32GB DDR5 6000MHz CL30. Produs IT profesional disponibil în stoc.",
    "features": [
      "32GB (2x16GB) DDR5",
      "6000MHz CL30",
      "XMP 3.0",
      "Low-profile design"
    ],
    "specs": [
      "32GB (2x16GB) DDR5",
      "6000MHz CL30",
      "XMP 3.0",
      "Low-profile design"
    ],
    "badge": null,
    "image": "https://www.corsair.com/medias/sys_master/images/images/h39/hfa/9003671683102/CMK32GX5M2B6000C30.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Corsair Vengeance 32GB DDR5 6000MHz CL30 — Interpersonal IT",
      "description": "Cumpără Corsair Vengeance 32GB DDR5 6000MHz CL30 la prețul de 718.8 RON cu TVA. Corsair disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Corsair, Corsair Vengeance 32GB DDR5 6000MHz CL30, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Corsair Romania / PC Garage",
    "purchasePrice": 495.04,
    "salePrice": 594.05,
    "salePriceTva": 718.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-06",
    "name": "NVIDIA RTX 4090 24GB GDDR6X Gigabyte AORUS",
    "slug": "comp-06-nvidia-rtx-4090-24gb-gddr6x-gigabyte-aorus",
    "brand": "NVIDIA",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 12891.58,
    "priceTva": 15598.81,
    "currency": "RON",
    "period": "once",
    "description": "NVIDIA — NVIDIA RTX 4090 24GB GDDR6X Gigabyte AORUS. Produs IT profesional disponibil în stoc.",
    "features": [
      "24GB GDDR6X",
      "PCIe 4.0 x16",
      "450W TDP",
      "DLSS 3.0 Frame Gen"
    ],
    "specs": [
      "24GB GDDR6X",
      "PCIe 4.0 x16",
      "450W TDP",
      "DLSS 3.0 Frame Gen"
    ],
    "badge": "Flagship",
    "image": "https://www.gigabyte.com/FileUpload/Global/KeyFeature/3424/kf-source-images/kf-01.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "NVIDIA RTX 4090 24GB GDDR6X Gigabyte AORUS — Interpersonal IT",
      "description": "Cumpără NVIDIA RTX 4090 24GB GDDR6X Gigabyte AORUS la prețul de 15598.81 RON cu TVA. NVIDIA disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "NVIDIA, NVIDIA RTX 4090 24GB GDDR6X Gigabyte AORUS, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "ASUS Romania / PC Garage",
    "purchasePrice": 10742.98,
    "salePrice": 12891.58,
    "salePriceTva": 15598.81,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-07",
    "name": "Kingston KC3000 2TB M.2 PCIe 4.0 NVMe",
    "slug": "comp-07-kingston-kc3000-2tb-m2-pcie-40-nvme",
    "brand": "Kingston",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 1070.09,
    "priceTva": 1294.81,
    "currency": "RON",
    "period": "once",
    "description": "Kingston — Kingston KC3000 2TB M.2 PCIe 4.0 NVMe. Produs IT profesional disponibil în stoc.",
    "features": [
      "2TB M.2 PCIe 4.0",
      "Citire 7000 MB/s",
      "Scriere 7000 MB/s",
      "NVMe 1.4"
    ],
    "specs": [
      "2TB M.2 PCIe 4.0",
      "Citire 7000 MB/s",
      "Scriere 7000 MB/s",
      "NVMe 1.4"
    ],
    "badge": null,
    "image": "https://www.kingston.com/dataSheets/SKC3000D_2048G_en.jpg",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Kingston KC3000 2TB M.2 PCIe 4.0 NVMe — Interpersonal IT",
      "description": "Cumpără Kingston KC3000 2TB M.2 PCIe 4.0 NVMe la prețul de 1294.81 RON cu TVA. Kingston disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "Kingston, Kingston KC3000 2TB M.2 PCIe 4.0 NVMe, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Kingston Technology Romania",
    "purchasePrice": 891.74,
    "salePrice": 1070.09,
    "salePriceTva": 1294.81,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-08",
    "name": "AMD Ryzen 9 7950X3D 5.7GHz AM5 Box",
    "slug": "comp-08-amd-ryzen-9-7950x3d-57ghz-am5-box",
    "brand": "AMD",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 3668.42,
    "priceTva": 4438.79,
    "currency": "RON",
    "period": "once",
    "description": "AMD — AMD Ryzen 9 7950X3D 5.7GHz AM5 Box. Produs IT profesional disponibil în stoc.",
    "features": [
      "16 core / 32 thread",
      "5.7GHz Boost",
      "128MB L3 3D V-Cache",
      "Socket AM5, TDP 120W"
    ],
    "specs": [
      "16 core / 32 thread",
      "5.7GHz Boost",
      "128MB L3 3D V-Cache",
      "Socket AM5, TDP 120W"
    ],
    "badge": "Flagship",
    "image": "https://cdn.amd.com/System/Product%20Resources/17/17-001/02_7950x3d_pib.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "AMD Ryzen 9 7950X3D 5.7GHz AM5 Box — Interpersonal IT",
      "description": "Cumpără AMD Ryzen 9 7950X3D 5.7GHz AM5 Box la prețul de 4438.79 RON cu TVA. AMD disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "AMD, AMD Ryzen 9 7950X3D 5.7GHz AM5 Box, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "AMD Romania / eMAG Business",
    "purchasePrice": 3057.02,
    "salePrice": 3668.42,
    "salePriceTva": 4438.79,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-09",
    "name": "ASUS ROG STRIX Z790-F Wi-Fi 6E Motherboard",
    "slug": "comp-09-asus-rog-strix-z790-f-wi-fi-6e-motherboard",
    "brand": "ASUS",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 2180.83,
    "priceTva": 2638.8,
    "currency": "RON",
    "period": "once",
    "description": "ASUS — ASUS ROG STRIX Z790-F Wi-Fi 6E Motherboard. Produs IT profesional disponibil în stoc.",
    "features": [
      "Intel Z790 LGA1700",
      "Wi-Fi 6E, BT 5.3",
      "4x M.2 PCIe 5.0/4.0",
      "DDR5 support 7800+ MHz"
    ],
    "specs": [
      "Intel Z790 LGA1700",
      "Wi-Fi 6E, BT 5.3",
      "4x M.2 PCIe 5.0/4.0",
      "DDR5 support 7800+ MHz"
    ],
    "badge": "Gaming",
    "image": "https://dlcdnets.asus.com/pub/ASUS/mb/LGA1700/ROG_STRIX_Z790-F_GAMING_WIFI/90MB1CM0-M0EAY0.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "ASUS ROG STRIX Z790-F Wi-Fi 6E Motherboard — Interpersonal IT",
      "description": "Cumpără ASUS ROG STRIX Z790-F Wi-Fi 6E Motherboard la prețul de 2638.8 RON cu TVA. ASUS disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "ASUS, ASUS ROG STRIX Z790-F Wi-Fi 6E Motherboard, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "ASUS Romania / PC Garage",
    "purchasePrice": 1817.36,
    "salePrice": 2180.83,
    "salePriceTva": 2638.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "comp-10",
    "name": "be quiet! Dark Power 13 1000W 80+ Titanium",
    "slug": "comp-10-be-quiet-dark-power-13-1000w-80-titanium",
    "brand": "be quiet!",
    "type": "hardware",
    "category": "it-hardware",
    "categoryLabel": "IT & Hardware",
    "subcategory": "componente",
    "subcategoryLabel": "Componente PC & Gaming",
    "price": 990.74,
    "priceTva": 1198.8,
    "currency": "RON",
    "period": "once",
    "description": "be quiet! — be quiet! Dark Power 13 1000W 80+ Titanium. Produs IT profesional disponibil în stoc.",
    "features": [
      "1000W ATX 3.0",
      "80+ Titanium",
      "Modulare completă",
      "PCIe 5.0 connector"
    ],
    "specs": [
      "1000W ATX 3.0",
      "80+ Titanium",
      "Modulare completă",
      "PCIe 5.0 connector"
    ],
    "badge": null,
    "image": "https://www.bequiet.com/wsc/be-quiet/images/products/power-supply/dark-power-13/main/dark-power-13-regular.png",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "be quiet! Dark Power 13 1000W 80+ Titanium — Interpersonal IT",
      "description": "Cumpără be quiet! Dark Power 13 1000W 80+ Titanium la prețul de 1198.8 RON cu TVA. be quiet! disponibil la Interpersonal IT cu livrare rapidă.",
      "keywords": "be quiet!, be quiet! Dark Power 13 1000W 80+ Titanium, Componente PC & Gaming, cumpara online Romania"
    },
    "requiresShipping": true,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "be quiet! / PC Garage Romania",
    "purchasePrice": 825.62,
    "salePrice": 990.74,
    "salePriceTva": 1198.8,
    "margin": 20.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "whs-start",
    "name": "Web Hosting Standard Start",
    "slug": "whs-start-web-hosting-standard-start",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "hosting-standard",
    "subcategoryLabel": "Hosting Standard",
    "price": 2.89,
    "priceTva": 3.5,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Web Hosting Standard Start — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "1 domeniu inclus",
      "5 GB SSD spațiu",
      "5 adrese email",
      "SSL gratuit",
      "cPanel / WHM",
      "Uptime 99.9%"
    ],
    "specs": [
      "1 domeniu inclus",
      "5 GB SSD spațiu",
      "5 adrese email",
      "SSL gratuit",
      "cPanel / WHM",
      "Uptime 99.9%"
    ],
    "badge": null,
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Web Hosting Standard Start — Interpersonal Hosting",
      "description": "Plan Web Hosting Standard Start la 2.89 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Hosting Standard, Web Hosting Standard Start"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 1.99,
    "salePrice": 2.89,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "whs-business",
    "name": "Web Hosting Standard Business",
    "slug": "whs-business-web-hosting-standard-business",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "hosting-standard",
    "subcategoryLabel": "Hosting Standard",
    "price": 5.79,
    "priceTva": 7.01,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Web Hosting Standard Business — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "3 domenii incluse",
      "20 GB SSD spațiu",
      "20 adrese email",
      "SSL gratuit",
      "cPanel / WHM",
      "Backup zilnic"
    ],
    "specs": [
      "3 domenii incluse",
      "20 GB SSD spațiu",
      "20 adrese email",
      "SSL gratuit",
      "cPanel / WHM",
      "Backup zilnic"
    ],
    "badge": "Popular",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Web Hosting Standard Business — Interpersonal Hosting",
      "description": "Plan Web Hosting Standard Business la 5.79 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Hosting Standard, Web Hosting Standard Business"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 3.99,
    "salePrice": 5.79,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "whs-enterprise",
    "name": "Web Hosting Standard Enterprise",
    "slug": "whs-enterprise-web-hosting-standard-enterprise",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "hosting-standard",
    "subcategoryLabel": "Hosting Standard",
    "price": 11.59,
    "priceTva": 14.02,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Web Hosting Standard Enterprise — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "Domenii nelimitate",
      "100 GB SSD spațiu",
      "Email nelimitat",
      "SSL gratuit",
      "cPanel / WHM",
      "Backup zilnic prioritar"
    ],
    "specs": [
      "Domenii nelimitate",
      "100 GB SSD spațiu",
      "Email nelimitat",
      "SSL gratuit",
      "cPanel / WHM",
      "Backup zilnic prioritar"
    ],
    "badge": "Business",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Web Hosting Standard Enterprise — Interpersonal Hosting",
      "description": "Plan Web Hosting Standard Enterprise la 11.59 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Hosting Standard, Web Hosting Standard Enterprise"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 7.99,
    "salePrice": 11.59,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "whp-nano",
    "name": "Web Hosting Premium Nano (NVMe)",
    "slug": "whp-nano-web-hosting-premium-nano-nvme",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "hosting-premium",
    "subcategoryLabel": "Hosting Premium NVMe",
    "price": 3.61,
    "priceTva": 4.37,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Web Hosting Premium Nano (NVMe) — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "1 domeniu inclus",
      "10 GB NVMe spațiu",
      "10 adrese email",
      "SSL gratuit",
      "LiteSpeed + LSCache",
      "NVMe ultra-rapid"
    ],
    "specs": [
      "1 domeniu inclus",
      "10 GB NVMe spațiu",
      "10 adrese email",
      "SSL gratuit",
      "LiteSpeed + LSCache",
      "NVMe ultra-rapid"
    ],
    "badge": "Nou",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Web Hosting Premium Nano (NVMe) — Interpersonal Hosting",
      "description": "Plan Web Hosting Premium Nano (NVMe) la 3.61 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Hosting Premium NVMe, Web Hosting Premium Nano (NVMe)"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 2.49,
    "salePrice": 3.61,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "whp-start",
    "name": "Web Hosting Premium Start (NVMe)",
    "slug": "whp-start-web-hosting-premium-start-nvme",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "hosting-premium",
    "subcategoryLabel": "Hosting Premium NVMe",
    "price": 6.51,
    "priceTva": 7.88,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Web Hosting Premium Start (NVMe) — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "3 domenii incluse",
      "25 GB NVMe spațiu",
      "Emailuri nelimitate",
      "SSL gratuit",
      "LiteSpeed + LSCache",
      "Redis, Memcached"
    ],
    "specs": [
      "3 domenii incluse",
      "25 GB NVMe spațiu",
      "Emailuri nelimitate",
      "SSL gratuit",
      "LiteSpeed + LSCache",
      "Redis, Memcached"
    ],
    "badge": "Recomandat",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Web Hosting Premium Start (NVMe) — Interpersonal Hosting",
      "description": "Plan Web Hosting Premium Start (NVMe) la 6.51 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Hosting Premium NVMe, Web Hosting Premium Start (NVMe)"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 4.49,
    "salePrice": 6.51,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "whp-business",
    "name": "Web Hosting Premium Business (NVMe)",
    "slug": "whp-business-web-hosting-premium-business-nvme",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "hosting-premium",
    "subcategoryLabel": "Hosting Premium NVMe",
    "price": 13.04,
    "priceTva": 15.78,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Web Hosting Premium Business (NVMe) — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "Domenii nelimitate",
      "60 GB NVMe spațiu",
      "Emailuri nelimitate",
      "SSL gratuit",
      "LiteSpeed + LSCache",
      "Node.js, Python, Ruby"
    ],
    "specs": [
      "Domenii nelimitate",
      "60 GB NVMe spațiu",
      "Emailuri nelimitate",
      "SSL gratuit",
      "LiteSpeed + LSCache",
      "Node.js, Python, Ruby"
    ],
    "badge": "Popular",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Web Hosting Premium Business (NVMe) — Interpersonal Hosting",
      "description": "Plan Web Hosting Premium Business (NVMe) la 13.04 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Hosting Premium NVMe, Web Hosting Premium Business (NVMe)"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 8.99,
    "salePrice": 13.04,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "whp-enterprise",
    "name": "Web Hosting Premium Enterprise (NVMe)",
    "slug": "whp-enterprise-web-hosting-premium-enterprise-nvme",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "hosting-premium",
    "subcategoryLabel": "Hosting Premium NVMe",
    "price": 21.74,
    "priceTva": 26.31,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Web Hosting Premium Enterprise (NVMe) — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "Domenii nelimitate",
      "150 GB NVMe spațiu",
      "Emailuri nelimitate",
      "SSL EV gratuit",
      "LiteSpeed + LSCache",
      "Resurse dedicate"
    ],
    "specs": [
      "Domenii nelimitate",
      "150 GB NVMe spațiu",
      "Emailuri nelimitate",
      "SSL EV gratuit",
      "LiteSpeed + LSCache",
      "Resurse dedicate"
    ],
    "badge": "Enterprise",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Web Hosting Premium Enterprise (NVMe) — Interpersonal Hosting",
      "description": "Plan Web Hosting Premium Enterprise (NVMe) la 21.74 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Hosting Premium NVMe, Web Hosting Premium Enterprise (NVMe)"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 14.99,
    "salePrice": 21.74,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "vps-go0",
    "name": "Cloud VPS go0 — 1 vCPU / 2GB RAM",
    "slug": "vps-go0-cloud-vps-go0-1-vcpu-2gb-ram",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "cloud-vps",
    "subcategoryLabel": "Cloud VPS",
    "price": 8.69,
    "priceTva": 10.51,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Cloud VPS go0 — 1 vCPU / 2GB RAM — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "1 vCPU",
      "2 GB RAM",
      "25 GB NVMe SSD",
      "1 IPv4 dedicat",
      "Trafic nelimitat",
      "Panou de control inclus"
    ],
    "specs": [
      "1 vCPU",
      "2 GB RAM",
      "25 GB NVMe SSD",
      "1 IPv4 dedicat",
      "Trafic nelimitat",
      "Panou de control inclus"
    ],
    "badge": null,
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Cloud VPS go0 — 1 vCPU / 2GB RAM — Interpersonal Hosting",
      "description": "Plan Cloud VPS go0 — 1 vCPU / 2GB RAM la 8.69 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Cloud VPS, Cloud VPS go0 — 1 vCPU / 2GB RAM"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 5.99,
    "salePrice": 8.69,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "vps-go1",
    "name": "Cloud VPS go1 — 2 vCPU / 4GB RAM",
    "slug": "vps-go1-cloud-vps-go1-2-vcpu-4gb-ram",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "cloud-vps",
    "subcategoryLabel": "Cloud VPS",
    "price": 15.94,
    "priceTva": 19.29,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Cloud VPS go1 — 2 vCPU / 4GB RAM — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "2 vCPU",
      "4 GB RAM",
      "50 GB NVMe SSD",
      "1 IPv4 dedicat",
      "Trafic nelimitat",
      "Root access complet"
    ],
    "specs": [
      "2 vCPU",
      "4 GB RAM",
      "50 GB NVMe SSD",
      "1 IPv4 dedicat",
      "Trafic nelimitat",
      "Root access complet"
    ],
    "badge": "Popular",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Cloud VPS go1 — 2 vCPU / 4GB RAM — Interpersonal Hosting",
      "description": "Plan Cloud VPS go1 — 2 vCPU / 4GB RAM la 15.94 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Cloud VPS, Cloud VPS go1 — 2 vCPU / 4GB RAM"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 10.99,
    "salePrice": 15.94,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "vps-go2",
    "name": "Cloud VPS go2 — 4 vCPU / 8GB RAM",
    "slug": "vps-go2-cloud-vps-go2-4-vcpu-8gb-ram",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "cloud-vps",
    "subcategoryLabel": "Cloud VPS",
    "price": 28.99,
    "priceTva": 35.08,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Cloud VPS go2 — 4 vCPU / 8GB RAM — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "4 vCPU",
      "8 GB RAM",
      "100 GB NVMe SSD",
      "2 IPv4 dedicate",
      "Trafic nelimitat",
      "Snapshot & backup automat"
    ],
    "specs": [
      "4 vCPU",
      "8 GB RAM",
      "100 GB NVMe SSD",
      "2 IPv4 dedicate",
      "Trafic nelimitat",
      "Snapshot & backup automat"
    ],
    "badge": "Recomandat",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Cloud VPS go2 — 4 vCPU / 8GB RAM — Interpersonal Hosting",
      "description": "Plan Cloud VPS go2 — 4 vCPU / 8GB RAM la 28.99 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Cloud VPS, Cloud VPS go2 — 4 vCPU / 8GB RAM"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 19.99,
    "salePrice": 28.99,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "vps-go3",
    "name": "Cloud VPS go3 — 6 vCPU / 16GB RAM",
    "slug": "vps-go3-cloud-vps-go3-6-vcpu-16gb-ram",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "cloud-vps",
    "subcategoryLabel": "Cloud VPS",
    "price": 50.74,
    "priceTva": 61.4,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Cloud VPS go3 — 6 vCPU / 16GB RAM — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "6 vCPU",
      "16 GB RAM",
      "200 GB NVMe SSD",
      "2 IPv4 dedicate",
      "Trafic nelimitat",
      "DDoS protection"
    ],
    "specs": [
      "6 vCPU",
      "16 GB RAM",
      "200 GB NVMe SSD",
      "2 IPv4 dedicate",
      "Trafic nelimitat",
      "DDoS protection"
    ],
    "badge": "Business",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Cloud VPS go3 — 6 vCPU / 16GB RAM — Interpersonal Hosting",
      "description": "Plan Cloud VPS go3 — 6 vCPU / 16GB RAM la 50.74 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Cloud VPS, Cloud VPS go3 — 6 vCPU / 16GB RAM"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 34.99,
    "salePrice": 50.74,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "vps-go4",
    "name": "Cloud VPS go4 — 8 vCPU / 32GB RAM",
    "slug": "vps-go4-cloud-vps-go4-8-vcpu-32gb-ram",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "cloud-vps",
    "subcategoryLabel": "Cloud VPS",
    "price": 86.99,
    "priceTva": 105.26,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Cloud VPS go4 — 8 vCPU / 32GB RAM — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "8 vCPU",
      "32 GB RAM",
      "400 GB NVMe SSD",
      "4 IPv4 dedicate",
      "Trafic nelimitat",
      "DDoS + Firewall hardware"
    ],
    "specs": [
      "8 vCPU",
      "32 GB RAM",
      "400 GB NVMe SSD",
      "4 IPv4 dedicate",
      "Trafic nelimitat",
      "DDoS + Firewall hardware"
    ],
    "badge": "Enterprise",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Cloud VPS go4 — 8 vCPU / 32GB RAM — Interpersonal Hosting",
      "description": "Plan Cloud VPS go4 — 8 vCPU / 32GB RAM la 86.99 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Cloud VPS, Cloud VPS go4 — 8 vCPU / 32GB RAM"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 59.99,
    "salePrice": 86.99,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "reseller-starter",
    "name": "Reseller Hosting Starter — 10 conturi",
    "slug": "reseller-starter-reseller-hosting-starter-10-conturi",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "reseller",
    "subcategoryLabel": "Reseller Hosting",
    "price": 18.84,
    "priceTva": 22.8,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Reseller Hosting Starter — 10 conturi — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "10 conturi cPanel",
      "WHM inclus",
      "50 GB spațiu total",
      "SSL Let's Encrypt auto",
      "Branding WHM personalizat",
      "WHMCS ready"
    ],
    "specs": [
      "10 conturi cPanel",
      "WHM inclus",
      "50 GB spațiu total",
      "SSL Let's Encrypt auto",
      "Branding WHM personalizat",
      "WHMCS ready"
    ],
    "badge": null,
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Reseller Hosting Starter — 10 conturi — Interpersonal Hosting",
      "description": "Plan Reseller Hosting Starter — 10 conturi la 18.84 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Reseller Hosting, Reseller Hosting Starter — 10 conturi"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 12.99,
    "salePrice": 18.84,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "reseller-business",
    "name": "Reseller Hosting Business — 25 conturi",
    "slug": "reseller-business-reseller-hosting-business-25-conturi",
    "brand": "Hostico.ro",
    "type": "hosting",
    "category": "hosting",
    "categoryLabel": "Hosting & Cloud",
    "subcategory": "reseller",
    "subcategoryLabel": "Reseller Hosting",
    "price": 33.34,
    "priceTva": 40.34,
    "currency": "EUR",
    "period": "monthly",
    "description": "Plan de găzduire web Reseller Hosting Business — 25 conturi — performanță și fiabilitate pentru afacerea ta.",
    "features": [
      "25 conturi cPanel",
      "WHM inclus",
      "150 GB spațiu total",
      "SSL Let's Encrypt auto",
      "Branding complet",
      "Suport prioritar"
    ],
    "specs": [
      "25 conturi cPanel",
      "WHM inclus",
      "150 GB spațiu total",
      "SSL Let's Encrypt auto",
      "Branding complet",
      "Suport prioritar"
    ],
    "badge": "Business",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Reseller Hosting Business — 25 conturi — Interpersonal Hosting",
      "description": "Plan Reseller Hosting Business — 25 conturi la 33.34 EUR/lună. Găzduire web profesională cu SSL gratuit și suport dedicat.",
      "keywords": "hosting web Romania, Reseller Hosting, Reseller Hosting Business — 25 conturi"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 5,
    "discount36m": 10,
    "supplier": "Hostico.ro",
    "purchasePrice": 22.99,
    "salePrice": 33.34,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "w1",
    "name": "Site de Prezentare",
    "slug": "w1-site-de-prezentare",
    "brand": "Interpersonal S.R.L.",
    "type": "webdesign",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "web-design",
    "subcategoryLabel": "Web Design",
    "price": 800,
    "priceTva": 968.0,
    "currency": "EUR",
    "period": "once",
    "description": "Site de prezentare profesional, optimizat pentru toate dispozitivele.",
    "features": [
      "Design modern responsive",
      "Până la 5 pagini",
      "CMS integrat",
      "Formulare contact",
      "SSL + hosting 1 an inclus",
      "SEO de bază"
    ],
    "specs": [
      "Design modern responsive",
      "Până la 5 pagini",
      "CMS integrat",
      "Formulare contact",
      "SSL + hosting 1 an inclus",
      "SEO de bază"
    ],
    "badge": null,
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Site de Prezentare — Interpersonal IT",
      "description": "Site de prezentare profesional, optimizat pentru toate dispozitivele. Preț: 800 EUR.",
      "keywords": "Web Design, Site de Prezentare, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 551.72,
    "salePrice": 800,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "w2",
    "name": "Site Business",
    "slug": "w2-site-business",
    "brand": "Interpersonal S.R.L.",
    "type": "webdesign",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "web-design",
    "subcategoryLabel": "Web Design",
    "price": 1500,
    "priceTva": 1815.0,
    "currency": "EUR",
    "period": "once",
    "description": "Site de afaceri complet cu CMS avansat, blog și funcționalități extinse.",
    "features": [
      "Design premium responsive",
      "Până la 15 pagini",
      "CMS avansat",
      "Blog integrat",
      "Multilingv RO/EN",
      "SEO avansat + Analytics"
    ],
    "specs": [
      "Design premium responsive",
      "Până la 15 pagini",
      "CMS avansat",
      "Blog integrat",
      "Multilingv RO/EN",
      "SEO avansat + Analytics"
    ],
    "badge": "Popular",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Site Business — Interpersonal IT",
      "description": "Site de afaceri complet cu CMS avansat, blog și funcționalități extinse. Preț: 1500 EUR.",
      "keywords": "Web Design, Site Business, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 1034.48,
    "salePrice": 1500,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "w3",
    "name": "Magazin Online E-Commerce",
    "slug": "w3-magazin-online-e-commerce",
    "brand": "Interpersonal S.R.L.",
    "type": "webdesign",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "web-design",
    "subcategoryLabel": "Web Design",
    "price": 3000,
    "priceTva": 3630.0,
    "currency": "EUR",
    "period": "once",
    "description": "Magazin online complet cu coș de cumpărături, plăți online și management produse.",
    "features": [
      "Catalog produse nelimitat",
      "Integrare plăți (Stripe/Netopia)",
      "Gestionare stocuri",
      "Facturare automată",
      "SEO e-commerce",
      "12 luni suport"
    ],
    "specs": [
      "Catalog produse nelimitat",
      "Integrare plăți (Stripe/Netopia)",
      "Gestionare stocuri",
      "Facturare automată",
      "SEO e-commerce",
      "12 luni suport"
    ],
    "badge": "Business",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Magazin Online E-Commerce — Interpersonal IT",
      "description": "Magazin online complet cu coș de cumpărături, plăți online și management produse. Preț: 3000 EUR.",
      "keywords": "Web Design, Magazin Online E-Commerce, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 2068.97,
    "salePrice": 3000,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "c1",
    "name": "Call Center Basic",
    "slug": "c1-call-center-basic",
    "brand": "Interpersonal S.R.L.",
    "type": "callcenter",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "call-center",
    "subcategoryLabel": "Call Center",
    "price": 500,
    "priceTva": 605.0,
    "currency": "EUR",
    "period": "monthly",
    "description": "Serviciu de call center inbound pentru companii mici și medii.",
    "features": [
      "Până la 5 agenți",
      "Rapoarte lunare",
      "Inbound apeluri",
      "Suport email",
      "IVR simplu"
    ],
    "specs": [
      "Până la 5 agenți",
      "Rapoarte lunare",
      "Inbound apeluri",
      "Suport email",
      "IVR simplu"
    ],
    "badge": null,
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Call Center Basic — Interpersonal IT",
      "description": "Serviciu de call center inbound pentru companii mici și medii. Preț: 500 EUR/monthly.",
      "keywords": "Call Center, Call Center Basic, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 344.83,
    "salePrice": 500,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "c2",
    "name": "Call Center Professional",
    "slug": "c2-call-center-professional",
    "brand": "Interpersonal S.R.L.",
    "type": "callcenter",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "call-center",
    "subcategoryLabel": "Call Center",
    "price": 1200,
    "priceTva": 1452.0,
    "currency": "EUR",
    "period": "monthly",
    "description": "Call center complet inbound+outbound cu integrare CRM și rapoarte avansate.",
    "features": [
      "Până la 20 agenți",
      "Rapoarte zilnice",
      "Inbound + Outbound",
      "Integrare CRM",
      "Înregistrare apeluri",
      "SLA garantat 95%"
    ],
    "specs": [
      "Până la 20 agenți",
      "Rapoarte zilnice",
      "Inbound + Outbound",
      "Integrare CRM",
      "Înregistrare apeluri",
      "SLA garantat 95%"
    ],
    "badge": "Business",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Call Center Professional — Interpersonal IT",
      "description": "Call center complet inbound+outbound cu integrare CRM și rapoarte avansate. Preț: 1200 EUR/monthly.",
      "keywords": "Call Center, Call Center Professional, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 827.59,
    "salePrice": 1200,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "voip1",
    "name": "Centrală VoIP Start",
    "slug": "voip1-centrala-voip-start",
    "brand": "Interpersonal S.R.L.",
    "type": "voip",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "voip",
    "subcategoryLabel": "VoIP / Telefonie",
    "price": 299,
    "priceTva": 361.79,
    "currency": "EUR",
    "period": "once",
    "description": "Soluție completă de telefonie VoIP pentru companii până la 20 utilizatori.",
    "features": [
      "Până la 20 extensii",
      "Auto-attendant IVR",
      "Softphone inclus",
      "Linie SIP trunk",
      "Instalare + configurare",
      "Suport 12 luni"
    ],
    "specs": [
      "Până la 20 extensii",
      "Auto-attendant IVR",
      "Softphone inclus",
      "Linie SIP trunk",
      "Instalare + configurare",
      "Suport 12 luni"
    ],
    "badge": null,
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Centrală VoIP Start — Interpersonal IT",
      "description": "Soluție completă de telefonie VoIP pentru companii până la 20 utilizatori. Preț: 299 EUR.",
      "keywords": "VoIP / Telefonie, Centrală VoIP Start, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 206.21,
    "salePrice": 299,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "voip2",
    "name": "Centrală VoIP Business",
    "slug": "voip2-centrala-voip-business",
    "brand": "Interpersonal S.R.L.",
    "type": "voip",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "voip",
    "subcategoryLabel": "VoIP / Telefonie",
    "price": 799,
    "priceTva": 966.79,
    "currency": "EUR",
    "period": "once",
    "description": "Soluție VoIP enterprise cu funcționalități avansate și disponibilitate 24/7.",
    "features": [
      "Extensii nelimitate",
      "Call recording",
      "Video conferință HD",
      "CRM integration",
      "Failover redundanță",
      "Suport prioritar 24/7"
    ],
    "specs": [
      "Extensii nelimitate",
      "Call recording",
      "Video conferință HD",
      "CRM integration",
      "Failover redundanță",
      "Suport prioritar 24/7"
    ],
    "badge": "Enterprise",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "Centrală VoIP Business — Interpersonal IT",
      "description": "Soluție VoIP enterprise cu funcționalități avansate și disponibilitate 24/7. Preț: 799 EUR.",
      "keywords": "VoIP / Telefonie, Centrală VoIP Business, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 551.03,
    "salePrice": 799,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "crm1",
    "name": "CRM Business",
    "slug": "crm1-crm-business",
    "brand": "Interpersonal S.R.L.",
    "type": "crm",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "crm",
    "subcategoryLabel": "Software CRM",
    "price": 200,
    "priceTva": 242.0,
    "currency": "EUR",
    "period": "monthly",
    "description": "Sistem CRM complet pentru gestionarea clienților, vânzărilor și automatizărilor.",
    "features": [
      "Pipeline vânzări",
      "Automatizări email",
      "Integrare telefonie",
      "Mobile app",
      "Rapoarte avansate",
      "API access"
    ],
    "specs": [
      "Pipeline vânzări",
      "Automatizări email",
      "Integrare telefonie",
      "Mobile app",
      "Rapoarte avansate",
      "API access"
    ],
    "badge": "Popular",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "CRM Business — Interpersonal IT",
      "description": "Sistem CRM complet pentru gestionarea clienților, vânzărilor și automatizărilor. Preț: 200 EUR/monthly.",
      "keywords": "Software CRM, CRM Business, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 137.93,
    "salePrice": 200,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  },
  {
    "id": "crm2",
    "name": "CRM Enterprise",
    "slug": "crm2-crm-enterprise",
    "brand": "Interpersonal S.R.L.",
    "type": "crm",
    "category": "servicii",
    "categoryLabel": "Servicii",
    "subcategory": "crm",
    "subcategoryLabel": "Software CRM",
    "price": 500,
    "priceTva": 605.0,
    "currency": "EUR",
    "period": "monthly",
    "description": "CRM enterprise cu AI, utilizatori nelimitați și integrări avansate ERP.",
    "features": [
      "Utilizatori nelimitați",
      "AI insights",
      "Multi-pipeline",
      "Integrări ERP/Contabilitate",
      "White-label",
      "Suport dedicat"
    ],
    "specs": [
      "Utilizatori nelimitați",
      "AI insights",
      "Multi-pipeline",
      "Integrări ERP/Contabilitate",
      "White-label",
      "Suport dedicat"
    ],
    "badge": "Enterprise",
    "image": "",
    "highlighted": false,
    "status": "active",
    "inStock": true,
    "upsellIds": [],
    "crosssellIds": [],
    "seo": {
      "title": "CRM Enterprise — Interpersonal IT",
      "description": "CRM enterprise cu AI, utilizatori nelimitați și integrări avansate ERP. Preț: 500 EUR/monthly.",
      "keywords": "Software CRM, CRM Enterprise, servicii IT Romania"
    },
    "requiresShipping": false,
    "dimensions": {
      "l": 0,
      "w": 0,
      "h": 0
    },
    "weight": 0,
    "discount12m": 0,
    "discount24m": 0,
    "discount36m": 0,
    "supplier": "Interpersonal S.R.L.",
    "purchasePrice": 344.83,
    "salePrice": 500,
    "margin": 45.0,
    "updatedAt": "2026-05-01"
  }
];
export const defaultSettings: SiteSettings = {
  logoUrl: 'https://interpersonal.ro/uploads/logo/inter+logo.png',
  logoAlt: 'INTERPERSONAL S.R.L.',
  colors: {
    primary: '#295CA8', secondary: '#3D72B8', accent: '#4ab8ff',
    background: '#0a0c12', navBg: '#07090f',
  },
  phones: ['+40 758 011 010', '+40 745 032 222', '+40 741 407 595'],
  email: 'office@interpersonal.ro',
  address: 'Str. Orhideelor nr. 8, Sat Țegheș, Com. Domnești, Jud. Ilfov, 077091',
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=Str+Orhideelor+nr+8+Sat+Teghes+Com+Domnesti+Judetul+Ilfov+077091+Romania',
  social: {
    facebook: 'https://facebook.com/interpersonal.ro',
    linkedin: 'https://linkedin.com/company/interpersonal-ro',
    instagram: 'https://instagram.com/interpersonal.ro',
    whatsapp: 'https://wa.me/40745032222',
  },
  footerText: '© 2025 INTERPERSONAL S.R.L. · CUI RO34799221 · J2015002538235',
  gtmId: 'GTM-5ZW5DDR',
  ga4Id: 'G-6CJP50W0MD',
  googleApi: {
    clientId: '185237368738-tfmn55decj9hjrr0im5gspvuv79iktsl.apps.googleusercontent.com',
    clientSecret: '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',
    refreshToken: '',
    propertyId: '461287871',
    serviceAccountJson: '',
  },
};

/* ── Default SEO Pages ────────────────────────────────────────────────────── */
export const defaultSeoPages: SeoPage[] = [
  { id: 'home', path: '/', pageName: 'Pagina Principală',
    title: 'INTERPERSONAL S.R.L. | Web Design, Call Center, VoIP, Hosting, CRM — Ilfov, România',
    description: 'INTERPERSONAL S.R.L. — furnizor complet de servicii și produse IT certificat ISO 9001 & ISO 27001: Web Design, Call Center, IT Hardware, Găzduire Web, Telefonie VoIP, CRM & Software. Ilfov, România.',
    keywords: 'web design Romania, call center solutii, IT hardware Ilfov, gazduire VPS, telefonie VoIP, CRM software, servicii IT Ilfov',
    ogTitle: 'INTERPERSONAL S.R.L. | Furnizor Servicii și Produse IT',
    ogDescription: 'Servicii complete IT: Web Design, Call Center, IT Hardware, Găzduire, VoIP, CRM. ISO 9001 & ISO 27001 certificat.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/', noindex: false },
  { id: 'webdesign', path: '/servicii/web-design', pageName: 'Web Design',
    title: 'Web Design Profesional România | Site-uri & Magazine Online — Interpersonal IT',
    description: 'Servicii web design profesional: site prezentare, site business, magazine online WooCommerce. Design responsive, SEO, performanță maximă. Ilfov, București.',
    keywords: 'web design Romania, creare site web, magazin online, WooCommerce, web design Ilfov',
    ogTitle: 'Web Design Profesional | Interpersonal IT',
    ogDescription: 'Creăm site-uri web și magazine online performante. De la prezentare la e-commerce complet.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/servicii/web-design', noindex: false },
  { id: 'callcenter', path: '/servicii/call-center', pageName: 'Call Center',
    title: 'Servicii Call Center Outsourcing România | Inbound & Outbound — Interpersonal',
    description: 'Servicii profesionale call center outsourcing: suport clienți inbound, telemarketing outbound, IVR, CRM integrat. Agenți dedicați în România.',
    keywords: 'call center outsourcing Romania, servicii call center, inbound call center, telemarketing',
    ogTitle: 'Call Center Outsourcing | Interpersonal IT',
    ogDescription: 'Externalizare call center cu agenți dedicați, IVR și rapoarte detaliate.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/servicii/call-center', noindex: false },
  { id: 'hosting', path: '/servicii/gazduire', pageName: 'Găzduire Web',
    title: 'Găzduire Web Profesională | Hosting SSD NVMe, VPS, SSL — Interpersonal IT',
    description: 'Pachete găzduire web cu SSD NVMe, uptime 99.9%, SSL gratuit, backup zilnic. Planuri START, BUSINESS și ENTERPRISE pentru orice nevoi.',
    keywords: 'gazduire web Romania, hosting SSD, VPS Romania, SSL certificate, hosting ieftin',
    ogTitle: 'Găzduire Web SSD NVMe | Interpersonal IT',
    ogDescription: 'Hosting profesional cu SSD NVMe, uptime 99.9% și SSL gratuit. Planuri de la 10 EUR/lună.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/servicii/gazduire', noindex: false },
  { id: 'voip', path: '/servicii/telefonie-voip', pageName: 'Telefonie VoIP',
    title: 'Telefonie VoIP Business | Centrale Asterisk, FreePBX — Interpersonal IT',
    description: 'Implementare sisteme VoIP business: centrale Asterisk/FreePBX, SIP trunk, softphone, IVR. Reduceri costuri telefonie până la 70%.',
    keywords: 'telefonie VoIP, centrala Asterisk, FreePBX, SIP trunk, VoIP business',
    ogTitle: 'Telefonie VoIP pentru Business | Interpersonal IT',
    ogDescription: 'Centrale VoIP Asterisk/FreePBX cu SIP trunk și softphone. Reduceri costuri 70%.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/servicii/telefonie-voip', noindex: false },
  { id: 'crm', path: '/servicii/crm-software', pageName: 'CRM & Software',
    title: 'CRM & Software Business România | ERP, Automatizare — Interpersonal IT',
    description: 'Implementare CRM, ERP și software business personalizat. Automatizare procese, pipeline vânzări, rapoarte avansate. Soluții complete pentru afacerea ta.',
    keywords: 'CRM Romania, ERP Romania, software business, automatizare procese, managementul vanzarilor',
    ogTitle: 'CRM & Software Business | Interpersonal IT',
    ogDescription: 'CRM și ERP customizat cu automatizări, pipeline vânzări și rapoarte avansate.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/servicii/crm-software', noindex: false },
  { id: 'contact', path: '/contact', pageName: 'Contact',
    title: 'Contact INTERPERSONAL S.R.L. | Ilfov, România',
    description: 'Contactați INTERPERSONAL S.R.L.: Str. Orhideelor nr. 8, Sat Țegheș, Com. Domnești, Jud. Ilfov. Tel: +40 758 011 010. Email: office@interpersonal.ro.',
    keywords: 'contact interpersonal, servicii IT Ilfov, telefon interpersonal',
    ogTitle: 'Contact | INTERPERSONAL S.R.L.',
    ogDescription: 'Contactați-ne pentru o consultație gratuită. Suntem disponibili Luni-Vineri 09:00-18:00.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/contact', noindex: false },
  { id: 'clienti', path: '/clienti', pageName: 'Clienții Noștri',
    title: 'Portofoliu Clienți | 350+ Proiecte Realizate — Interpersonal IT',
    description: 'Portofoliu complet Interpersonal IT: 350+ clienți mulțumiți, 400+ proiecte finalizate în web design, e-commerce, hosting și servicii IT.',
    keywords: 'portofoliu web design Romania, proiecte realizate, clienti interpersonal',
    ogTitle: 'Portofoliu Clienți | Interpersonal IT',
    ogDescription: '350+ clienți mulțumiți și 400+ proiecte finalizate în 10+ ani de experiență.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/clienti', noindex: false },
  { id: 'blog', path: '/blog', pageName: 'Blog IT',
    title: 'Blog IT & Tehnologie | Sfaturi, Ghiduri, Tendințe — Interpersonal IT',
    description: 'Blog cu articole despre web design, hosting, VoIP, CRM și tendințe IT. Sfaturi practice de la experții Interpersonal IT.',
    keywords: 'blog IT Romania, web design tips, hosting ghid, VoIP tutorial, CRM Romania',
    ogTitle: 'Blog IT & Tehnologie | Interpersonal IT',
    ogDescription: 'Articole, ghiduri și tendințe IT de la experții Interpersonal.',
    ogImage: 'https://interpersonal.ro/uploads/img/Interpersonalnew.png',
    canonical: 'https://interpersonal.ro/blog', noindex: false },
];

/* ── Default Page Content ─────────────────────────────────────────────────── */
export const defaultPages: PageContent[] = [
  {
    id: 'home', pageId: 'home', pageName: 'Pagina Principala', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_home_hero', label: 'Hero - Titlu principal',
        roText: `<h1>Solutii IT Complete pentru Afacerea Ta</h1><p>INTERPERSONAL S.R.L. este partenerul tau de incredere pentru transformare digitala - web design, hosting profesional, telefonie VoIP, call center, echipamente IT si software CRM. Certificati ISO 9001 si ISO 27001, cu peste 10 ani de experienta.</p>`,
        enText: `<h1>Complete IT Solutions for Your Business</h1><p>INTERPERSONAL S.R.L. is your trusted partner for digital transformation - web design, professional hosting, VoIP telephony, call center, IT hardware and CRM software. ISO 9001 and ISO 27001 certified, with over 10 years of experience.</p>`,
        imageUrl: '/images/interpersonal_home_v3_cinematic.webp'
      },
      {
        id: 's_home_about', label: 'Despre noi - paragraf introductiv',
        roText: `<h2>Cine Suntem</h2><p>INTERPERSONAL S.R.L. (CUI: RO34799221) este un furnizor complet de servicii si produse IT, cu sediul in Romania. Lucram cu companii din toate sectoarele economice, de la startup-uri la corporatii, livrind solutii personalizate, stabile si scalabile.</p><p>De la consultanta initiala pana la implementare si suport continuu, echipa noastra de specialisti se asigura ca infrastructura digitala a afacerii tale functioneaza perfect, in siguranta si eficienta maxima.</p>`,
        enText: `<h2>Who We Are</h2><p>INTERPERSONAL S.R.L. (CUI: RO34799221) is a full-service IT solutions provider based in Romania. We work with companies across all economic sectors, from startups to corporations, delivering tailored, stable and scalable solutions.</p><p>From initial consulting through implementation and ongoing support, our team of specialists ensures your business digital infrastructure runs flawlessly, securely and at maximum efficiency.</p>`,
        imageUrl: ''
      },
      {
        id: 's_home_services', label: 'Servicii - descriere',
        roText: `<h2>Serviciile Noastre</h2><p>Oferim un portofoliu complet de solutii digitale:</p><ul><li><strong>Web Design &amp; Development</strong> - site-uri profesionale, magazine online, aplicatii web</li><li><strong>Gazduire Web (Hosting)</strong> - servere stabile, SSL gratuit, suport 24/7</li><li><strong>Telefonie VoIP</strong> - centrale IP, reduceri de costuri pana la 65%</li><li><strong>Call Center</strong> - servicii externalizate sau implementare interna</li><li><strong>IT Hardware</strong> - echipamente de retea, servere, statii de lucru</li><li><strong>Software CRM</strong> - implementare, configurare si integrare cu sistemele existente</li></ul>`,
        enText: `<h2>Our Services</h2><p>We offer a complete portfolio of digital solutions:</p><ul><li><strong>Web Design &amp; Development</strong> - professional websites, online stores, web applications</li><li><strong>Web Hosting</strong> - stable servers, free SSL, 24/7 support</li><li><strong>VoIP Telephony</strong> - IP exchanges, cost reductions up to 65%</li><li><strong>Call Center</strong> - outsourced services or internal implementation</li><li><strong>IT Hardware</strong> - network equipment, servers, workstations</li><li><strong>CRM Software</strong> - implementation, configuration and integration</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_home_cta', label: 'CTA - Consultatie gratuita',
        roText: `<h2>Hai sa Discutam</h2><p>Contactati-ne pentru o consultatie gratuita si o oferta personalizata pentru nevoile afacerii dumneavoastra. Raspundem in maximum 2 ore in zilele lucratoare.</p>`,
        enText: `<h2>Let's Talk</h2><p>Contact us for a free consultation and a personalized offer tailored to your business needs. We respond within 2 hours on business days.</p>`,
        imageUrl: ''
      }
    ]
  },
  {
    id: 'webdesign', pageId: 'webdesign', pageName: 'Web Design', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_webdesign_hero', label: 'Hero - Web Design',
        roText: `<h1>Web Design &amp; Development Profesional</h1><p>Cream site-uri web care convertesc vizitatorii in clienti. De la prezentari corporate la magazine online complexe, fiecare proiect este conceput cu atentie la detalii, optimizat pentru SEO si performanta maxima.</p>`,
        enText: `<h1>Professional Web Design &amp; Development</h1><p>We create websites that convert visitors into clients. From corporate presentations to complex online stores, every project is crafted with attention to detail, optimized for SEO and maximum performance.</p>`,
        imageUrl: '/images/0c1633e3-69db-468a-ab21-1aede2440126.webp'
      },
      {
        id: 's_webdesign_process', label: 'Procesul de lucru',
        roText: `<h2>Procesul Nostru de Lucru</h2><p>Fiecare proiect web trece prin 6 etape bine definite:</p><ol><li><strong>Consultanta &amp; Brief</strong> - intelegem obiectivele tale si piata tinta</li><li><strong>Wireframing &amp; UX</strong> - structuram informatia pentru conversii maxime</li><li><strong>Design vizual</strong> - cream identitatea vizuala aliniata cu brandul tau</li><li><strong>Dezvoltare</strong> - cod curat, responsive, optimizat pentru viteza</li><li><strong>Testare &amp; QA</strong> - verificam pe toate dispozitivele si browserele</li><li><strong>Lansare &amp; Suport</strong> - publicam si oferim suport continuu</li></ol>`,
        enText: `<h2>Our Work Process</h2><p>Every web project goes through 6 well-defined stages:</p><ol><li><strong>Consultation &amp; Brief</strong> - we understand your goals and target market</li><li><strong>Wireframing &amp; UX</strong> - we structure information for maximum conversions</li><li><strong>Visual design</strong> - we create visual identity aligned with your brand</li><li><strong>Development</strong> - clean, responsive, speed-optimized code</li><li><strong>Testing &amp; QA</strong> - verified on all devices and browsers</li><li><strong>Launch &amp; Support</strong> - we publish and provide ongoing support</li></ol>`,
        imageUrl: ''
      },
      {
        id: 's_webdesign_plans', label: 'Pachete disponibile',
        roText: `<h2>Pachete Web Design</h2><p>Oferim trei pachete principale, adaptabile la nevoile oricarei afaceri:</p><ul><li><strong>START</strong> - Site de prezentare (5-10 pagini), design modern, mobile-first, SEO de baza, SSL gratuit. Ideal pentru companii mici si freelanceri.</li><li><strong>BUSINESS</strong> - Site complex cu blog, formulare avansate, integari (newsletter, chat, CRM), analytics. Recomandat pentru IMM-uri active online.</li><li><strong>E-COMMERCE</strong> - Magazin online complet: catalog produse, cos de cumparaturi, multiple metode de plata, gestionare comenzi si stocuri.</li></ul>`,
        enText: `<h2>Web Design Packages</h2><p>We offer three main packages, adaptable to any business needs:</p><ul><li><strong>START</strong> - Presentation website (5-10 pages), modern design, mobile-first, basic SEO, free SSL. Ideal for small companies and freelancers.</li><li><strong>BUSINESS</strong> - Complex site with blog, advanced forms, integrations (newsletter, chat, CRM), analytics. Recommended for SMEs active online.</li><li><strong>E-COMMERCE</strong> - Complete online store: product catalog, shopping cart, multiple payment methods, order and stock management.</li></ul>`,
        imageUrl: ''
      }
    ]
  },
  {
    id: 'hosting', pageId: 'hosting', pageName: 'Gazduire Web (Hosting)', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_hosting_hero', label: 'Hero - Hosting',
        roText: `<h1>Gazduire Web Profesionala</h1><p>Servere stabile cu uptime garantat 99.9%, localizate in Romania, cu cPanel intuitiv, SSL gratuit si suport tehnic 24/7. Planuri de la 12 luni - nicio surpriza lunara, preturi clare si transparente.</p>`,
        enText: `<h1>Professional Web Hosting</h1><p>Stable servers with 99.9% guaranteed uptime, located in Romania, with intuitive cPanel, free SSL and 24/7 technical support. Plans from 12 months - no monthly surprises, clear and transparent pricing.</p>`,
        imageUrl: '/hosting-service.webp'
      },
      {
        id: 's_hosting_features', label: 'Caracteristici incluse',
        roText: `<h2>Ce Este Inclus in Toate Planurile</h2><ul><li>SSL/TLS gratuit (Let's Encrypt sau certificat premium)</li><li>cPanel / Plesk - panou de control intuitiv</li><li>Backup zilnic automat (retentie 30 zile)</li><li>Protectie DDoS la nivel de datacenter</li><li>Servere NVMe SSD - viteza de 10x fata de HDD</li><li>Suport tehnic in romana, 24/7, raspuns in max 4 ore</li><li>Email profesional nelimitat (@domeniultau.ro)</li><li>Instalare WordPress/Joomla/PrestaShop cu 1 click</li></ul>`,
        enText: `<h2>What Is Included in All Plans</h2><ul><li>Free SSL/TLS (Let's Encrypt or premium certificate)</li><li>cPanel / Plesk - intuitive control panel</li><li>Automatic daily backup (30 days retention)</li><li>DDoS protection at datacenter level</li><li>NVMe SSD servers - 10x faster than HDD</li><li>Technical support in English, 24/7, response within 4 hours</li><li>Unlimited professional email (@yourdomain.com)</li><li>WordPress/Joomla/PrestaShop 1-click installation</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_hosting_pricing', label: 'Preturi si perioade',
        roText: `<h2>Perioade de Abonament</h2><p>Serviciile de hosting se vand in transe minime de <strong>12 luni</strong>. Nu exista abonament lunar - platesti o singura data pentru intreaga perioada si beneficiezi de pretul cel mai avantajos.</p><ul><li><strong>12 luni</strong> - pretul standard lunar x 12</li><li><strong>24 luni</strong> - reducere 5% fata de abonamentul anual</li><li><strong>36 luni</strong> - reducere 10% fata de abonamentul anual</li></ul><p>Toate preturile afisate sunt in EUR, fara TVA. TVA-ul de 19% se aplica la factura pentru clientii din Romania.</p>`,
        enText: `<h2>Subscription Periods</h2><p>Hosting services are sold in minimum tranches of <strong>12 months</strong>. There is no monthly subscription - you pay once for the entire period and benefit from the most advantageous price.</p><ul><li><strong>12 months</strong> - standard monthly price x 12</li><li><strong>24 months</strong> - 5% discount vs annual subscription</li><li><strong>36 months</strong> - 10% discount vs annual subscription</li></ul><p>All prices are in EUR, excluding VAT. 19% VAT applies on invoice for Romanian clients.</p>`,
        imageUrl: ''
      }
    ]
  },
  {
    id: 'callcenter', pageId: 'callcenter', pageName: 'Call Center', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_cc_hero', label: 'Hero - Call Center',
        roText: `<h1>Servicii Call Center Profesionale</h1><p>Externalizati sau implementati intern un call center eficient. Agenti calificati, infrastructura VoIP moderna, raportare in timp real si integrare cu CRM-ul dumneavoastra - totul gestionat de Interpersonal.</p>`,
        enText: `<h1>Professional Call Center Services</h1><p>Outsource or implement a call center internally. Qualified agents, modern VoIP infrastructure, real-time reporting and CRM integration - all managed by Interpersonal.</p>`,
        imageUrl: '/images/923c135d-aa04-4102-ad96-f4a8709ab8a3.webp'
      },
      {
        id: 's_cc_services', label: 'Tipuri de servicii',
        roText: `<h2>Servicii Disponibile</h2><ul><li><strong>Inbound Call Center</strong> - InfoLine, HelpDesk, preluare comenzi telefonice, suport tehnic nivel 1</li><li><strong>Outbound Call Center</strong> - telemarketing B2B/B2C, sondaje de satisfactie, recuperare creante, confirmare programari</li><li><strong>Chat Support</strong> - suport live pe website, integrare cu sistemele de ticketing</li><li><strong>Back Office Processing</strong> - procesare date, introducere informatii, verificare documente</li></ul>`,
        enText: `<h2>Available Services</h2><ul><li><strong>Inbound Call Center</strong> - InfoLine, HelpDesk, phone order taking, Level 1 technical support</li><li><strong>Outbound Call Center</strong> - B2B/B2C telemarketing, satisfaction surveys, debt recovery, appointment confirmation</li><li><strong>Chat Support</strong> - live website support, ticketing system integration</li><li><strong>Back Office Processing</strong> - data processing, information entry, document verification</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_cc_costs', label: 'Cost comparativ',
        roText: `<h2>De ce sa Externalizati Call Center-ul?</h2><p>Costul unui agent de call center intern (Romania, 2026): salariu brut 4.500-6.000 RON/luna, contributii angajator ~34%, echipament ~3.000-5.000 RON/agent, licente software CRM ~50-150 EUR/agent/luna. Cost total per agent: 8.000-12.000 RON/luna. Externalizand la Interpersonal, platiti doar pentru orele efectiv lucrate, fara costuri fixe de infrastructura sau resurse umane.</p>`,
        enText: `<h2>Why Outsource Your Call Center?</h2><p>Cost of an internal call center agent (Romania, 2026): gross salary 4,500-6,000 RON/month, employer contributions ~34%, equipment ~3,000-5,000 RON/agent, CRM software licenses ~50-150 EUR/agent/month. Total cost per agent: 8,000-12,000 RON/month. By outsourcing to Interpersonal, you only pay for hours actually worked, without fixed infrastructure or HR costs.</p>`,
        imageUrl: ''
      }
    ]
  },
  {
    id: 'voip', pageId: 'voip', pageName: 'Telefonie VoIP', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_voip_hero', label: 'Hero - VoIP',
        roText: `<h1>Telefonie VoIP pentru Afaceri</h1><p>Migrati la VoIP si reduceti costurile de telecomunicatii cu 40-65%. Centrale IP in cloud sau on-premise, portare numere existente, softphone pentru lucrul de acasa - implementare completa in 5-10 zile lucratoare.</p>`,
        enText: `<h1>VoIP Telephony for Businesses</h1><p>Migrate to VoIP and reduce telecommunication costs by 40-65%. Cloud or on-premise IP exchanges, existing number porting, softphone for home office - complete implementation in 5-10 business days.</p>`,
        imageUrl: '/callcenter-service.webp'
      },
      {
        id: 's_voip_savings', label: 'Economii si beneficii',
        roText: `<h2>Cat Economisesti Migrand la VoIP?</h2><p>Telefonie traditionala (PSTN/ISDN): linie telefonica fixa ~50-80 RON/luna/linie, apeluri nationale 0.04-0.08 RON/minut, apeluri internationale 0.25-1.50 RON/minut, centrala telefonica fizica 5.000-50.000 RON investitie.</p><p>VoIP: abonament SIP trunk de la 15 EUR/luna pentru 10 canale simultane, apeluri nationale 0.005-0.015 EUR/minut. <strong>Economii medii la migrare VoIP: 40-65% din costul lunar de telecomunicatii.</strong></p>`,
        enText: `<h2>How Much Do You Save by Migrating to VoIP?</h2><p>Traditional telephony (PSTN/ISDN): fixed telephone line ~50-80 RON/month/line, national calls 0.04-0.08 RON/minute, international calls 0.25-1.50 RON/minute, physical telephone exchange 5,000-50,000 RON investment.</p><p>VoIP: SIP trunk subscription from 15 EUR/month for 10 simultaneous channels, national calls 0.005-0.015 EUR/minute. <strong>Average savings on VoIP migration: 40-65% of monthly telecommunication cost.</strong></p>`,
        imageUrl: ''
      },
      {
        id: 's_voip_features', label: 'Functionalitati exclusive VoIP',
        roText: `<h2>Functionalitati Exclusive VoIP</h2><ul><li><strong>Softphone</strong> - apeluri de pe laptop/mobil, oriunde in lume, cu acelasi numar de firma</li><li><strong>Auto-attendant</strong> - meniu vocal automat 24/7 fara operator uman</li><li><strong>Call recording</strong> - inregistrare automata apeluri (conformitate GDPR)</li><li><strong>Video conferinta HD</strong> integrata - nu mai e nevoie de Zoom separat</li><li><strong>CRM integration</strong> - fisa clientului se deschide automat la apel primit</li><li><strong>Callback automat</strong> - programat sau imediat la eliberarea agentului</li><li><strong>Statistici in timp real</strong> - numar apeluri, durata medie, timp de asteptare</li></ul>`,
        enText: `<h2>Exclusive VoIP Features</h2><ul><li><strong>Softphone</strong> - calls from laptop/mobile, anywhere in the world, with the same business number</li><li><strong>Auto-attendant</strong> - automatic voice menu 24/7 without human operator</li><li><strong>Call recording</strong> - automatic call recording (GDPR compliant)</li><li><strong>Integrated HD video conferencing</strong> - no need for separate Zoom</li><li><strong>CRM integration</strong> - client file opens automatically on incoming call</li><li><strong>Automatic callback</strong> - scheduled or immediate when agent is free</li><li><strong>Real-time statistics</strong> - number of calls, average duration, wait time</li></ul>`,
        imageUrl: ''
      }
    ]
  },
  {
    id: 'crm', pageId: 'crm', pageName: 'Software CRM', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_crm_hero', label: 'Hero - CRM Software',
        roText: `<h1>Software CRM pentru Afaceri Romanesti</h1><p>Implementam si personalizam solutii CRM care centralizeaza toate informatiile despre clienti, automatizeaza procesele de vanzari si ofera vizibilitate completa asupra pipeline-ului. Companiile care folosesc CRM cresc vanzarile cu 29% si productivitatea cu 34%.</p>`,
        enText: `<h1>CRM Software for Romanian Businesses</h1><p>We implement and customize CRM solutions that centralize all client information, automate sales processes and provide complete visibility over the pipeline. Companies using CRM grow sales by 29% and productivity by 34%.</p>`,
        imageUrl: '/crm-service.webp'
      },
      {
        id: 's_crm_what', label: 'Ce este un CRM',
        roText: `<h2>Ce Este un CRM si De ce ai Nevoie</h2><p>CRM (Customer Relationship Management) este sistemul care centralizeaza toate informatiile despre clienti si interactiunile cu acestia: date contact, istoricul achizitiilor, conversatii, oferte trimise, statusul pipeline-ului de vanzari, sarcini si follow-up-uri.</p><p>Diferenta fata de Excel: automatizare (follow-up-uri trimise automat), vizibilitate (ce face fiecare agent in timp real), analytics (prognoza vanzarilor). Semnale ca ai nevoie urgent de un CRM: pierzi clienti pentru ca uiti sa dai follow-up, nu stii cate oferte active ai, datele despre clienti sunt raspandite in mai multe foi Excel sau emailuri.</p>`,
        enText: `<h2>What Is a CRM and Why Do You Need One</h2><p>CRM (Customer Relationship Management) is the system that centralizes all customer information and interactions: contact data, purchase history, conversations, sent offers, sales pipeline status, tasks and follow-ups.</p><p>The difference from Excel: automation (follow-ups sent automatically), visibility (what each agent does in real time), analytics (sales forecasting). Signs you urgently need a CRM: you lose clients because you forget to follow up, you do not know how many active offers you have, client data is spread across multiple Excel sheets or emails.</p>`,
        imageUrl: ''
      },
      {
        id: 's_crm_services', label: 'Servicii CRM oferite',
        roText: `<h2>Servicii CRM Oferite de Interpersonal</h2><ul><li><strong>Consultanta alegere CRM</strong> - analizam nevoile tale si recomandam solutia optima (HubSpot, Pipedrive, Zoho, Salesforce sau CRM custom)</li><li><strong>Implementare &amp; Configurare</strong> - setup complet, import date existente, configurare pipeline si campuri personalizate</li><li><strong>Integari</strong> - conectam CRM-ul cu site-ul, telefonia VoIP, facturare (SmartBill), email marketing</li><li><strong>Training echipa</strong> - sesiuni practice pentru manageri si agenti de vanzari</li><li><strong>Suport &amp; mentenanta</strong> - asistenta continua, actualizari, rapoarte personalizate</li></ul>`,
        enText: `<h2>CRM Services Offered by Interpersonal</h2><ul><li><strong>CRM selection consulting</strong> - we analyze your needs and recommend the optimal solution (HubSpot, Pipedrive, Zoho, Salesforce or custom CRM)</li><li><strong>Implementation &amp; Configuration</strong> - complete setup, existing data import, pipeline and custom field configuration</li><li><strong>Integrations</strong> - we connect CRM with your website, VoIP telephony, invoicing (SmartBill), email marketing</li><li><strong>Team training</strong> - practical sessions for managers and sales agents</li><li><strong>Support &amp; maintenance</strong> - ongoing assistance, updates, custom reports</li></ul>`,
        imageUrl: ''
      }
    ]
  },
  {
    id: 'contact', pageId: 'contact', pageName: 'Contact', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_contact_hero', label: 'Hero - Contact',
        roText: `<h1>Contactati-ne</h1><p>Suntem la dispozitia dumneavoastra pentru orice intrebare, solicitare de oferta sau consultanta tehnica. Raspundem in maximum 2 ore in zilele lucratoare (Luni-Vineri, 09:00-18:00).</p>`,
        enText: `<h1>Contact Us</h1><p>We are available for any questions, offer requests or technical consultations. We respond within 2 hours on business days (Monday-Friday, 09:00-18:00).</p>`,
        imageUrl: '/contact-banner.webp'
      },
      {
        id: 's_contact_info', label: 'Informatii de contact',
        roText: `<h2>Date de Contact</h2><ul><li>Telefon: +40 741 407 595</li><li>Email: office@interpersonal.ro</li><li>Adresa: Romania</li><li>Program: Luni-Vineri, 09:00-18:00</li></ul><p>Pentru urgente tehnice in afara programului, contactati-ne pe email - monitorizam permanent.</p>`,
        enText: `<h2>Contact Information</h2><ul><li>Phone: +40 741 407 595</li><li>Email: office@interpersonal.ro</li><li>Address: Romania</li><li>Hours: Monday-Friday, 09:00-18:00</li></ul><p>For technical emergencies outside business hours, contact us by email - we monitor continuously.</p>`,
        imageUrl: ''
      },
      {
        id: 's_contact_social', label: 'Retele sociale',
        roText: `<h2>Urmariti-ne</h2><p>Fiti la curent cu noutatile din lumea IT si ofertele noastre speciale urmarindu-ne pe retelele sociale. Publicam articole tehnice, studii de caz si promotii exclusive.</p>`,
        enText: `<h2>Follow Us</h2><p>Stay up to date with IT news and our special offers by following us on social media. We publish technical articles, case studies and exclusive promotions.</p>`,
        imageUrl: ''
      }
    ]
  },

  /* ── Termeni si Conditii ─────────────────────────────────────────────── */
  {
    id: 'termeni', pageId: 'termeni', pageName: 'Termeni si Conditii', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_termeni_1', label: '1. Definitii si Domeniu de Aplicare',
        roText: `<h2>1. Definitii si Domeniu de Aplicare</h2><p>Prezentele Termeni si Conditii Generale ("T&amp;C") reglementeaza relatia contractuala dintre INTERPERSONAL S.R.L. (denumit in continuare "Societatea", "Prestatorul" sau "Interpersonal"), cu sediul social in Str. Orhideelor nr. 8, Sat Teghes, Com. Domnesti, Jud. Ilfov, 077091, CUI RO34799221, numar de inregistrare J2015002538235, si persoanele fizice sau juridice care acceseaza site-ul web, utilizeaza serviciile sau achizitioneaza produse IT de la Interpersonal (denumiti "Client" sau "Utilizator"). Prin accesarea site-ului www.interpersonal.ro si utilizarea oricarui serviciu oferit, Clientul accepta integral si neconditionat prevederile prezentelor T&amp;C.</p>`,
        enText: `<h2>1. Definitions and Scope</h2><p>These General Terms and Conditions ("T&amp;C") govern the contractual relationship between INTERPERSONAL S.R.L. (hereinafter "the Company", "Provider" or "Interpersonal"), registered at Str. Orhideelor nr. 8, Sat Teghes, Com. Domnesti, Jud. Ilfov, 077091, VAT No. RO34799221, and individuals or legal entities accessing the website, using services or purchasing IT products from Interpersonal (referred to as "Client" or "User"). By accessing www.interpersonal.ro and using any offered service, the Client fully and unconditionally accepts these T&amp;C.</p>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_2', label: '2. Serviciile Oferite',
        roText: `<h2>2. Serviciile Oferite</h2><ul><li>Web design si dezvoltare aplicatii web personalizate</li><li>Hosting si solutii de gazduire web (shared, VPS, dedicat)</li><li>Telefonie VoIP si solutii de comunicatii IP</li><li>Call center: servicii de inbound, outbound si suport tehnic</li><li>Echipamente IT: calculatoare, laptopuri, servere, retele, periferice</li><li>Software CRM si aplicatii business personalizate</li><li>Consultanta IT si suport tehnic</li></ul>`,
        enText: `<h2>2. Services Offered</h2><ul><li>Web design and custom web application development</li><li>Hosting and web hosting solutions (shared, VPS, dedicated)</li><li>VoIP telephony and IP communication solutions</li><li>Call center: inbound, outbound and technical support services</li><li>IT equipment: computers, laptops, servers, networking, peripherals</li><li>CRM software and custom business applications</li><li>IT consulting and technical support</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_3', label: '3. Preturi, Taxe si Plati',
        roText: `<h2>3. Preturi, Taxe si Plati</h2><p>Preturile afisate sunt exprimate in lei (RON) si nu includ TVA (21%), daca nu se specifica altfel. Tarifele sunt cele valabile la data emiterii ofertei si pot fi modificate fara notificare prealabila. Plata se efectueaza conform conditiilor specificate in oferta sau contractul individual: avans (de regula 30-50%) la comanda si diferenta la finalizare. Interpersonal emite factura fiscala pentru toate serviciile prestate, conform legislatiei fiscale romane in vigoare.</p>`,
        enText: `<h2>3. Prices, Taxes and Payments</h2><p>Prices are expressed in RON and exclude VAT (21%) unless stated otherwise. Rates are valid at the date of offer issuance and may change without prior notice. Payment follows conditions in the offer or individual contract: advance payment (typically 30-50%) at order and the balance upon completion. Interpersonal issues fiscal invoices for all services per Romanian fiscal law.</p>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_4', label: '4. Termene de Livrare',
        roText: `<h2>4. Termene de Livrare</h2><p>Termenele de livrare sunt estimate si comunicate prin oferta sau comanda ferma. Interpersonal depune toate eforturile pentru respectarea termenelor comunicate, insa nu poate fi trasa la raspundere pentru depasiri cauzate de: lipsa materialelor/informatiilor de la Client, forta majora, sau circumstante tehnice exceptionale. Termenele curg din momentul primirii avansului si a tuturor datelor/materialelor necesare.</p>`,
        enText: `<h2>4. Delivery Timeframes</h2><p>Delivery timeframes are estimated and communicated through offers or firm orders. Interpersonal makes every effort to meet communicated deadlines but cannot be held liable for delays caused by: missing materials/information from the Client, force majeure, or exceptional technical circumstances. Timeframes begin upon receipt of advance payment and all required data/materials.</p>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_5', label: '5. Dreptul de Proprietate Intelectuala',
        roText: `<h2>5. Dreptul de Proprietate Intelectuala</h2><p>Drepturile de proprietate intelectuala asupra solutiilor create de Interpersonal (coduri sursa, design grafic, arhitecturi software) raman in proprietatea Societatii pana la achitarea integrala a pretului convenit. La plata integrala, drepturile se transfera Clientului conform conditiilor contractuale. Clientul nu are dreptul sa reproduca, distribuie, modifice sau comercializeze creatiile Interpersonal fara acordul scris prealabil.</p>`,
        enText: `<h2>5. Intellectual Property Rights</h2><p>Intellectual property rights over solutions created by Interpersonal (source code, graphic design, software architectures) remain the property of the Company until full payment of the agreed price. Upon full payment, rights are transferred to the Client per contractual terms. The Client may not reproduce, distribute, modify or commercialize Interpersonal creations without prior written consent.</p>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_6', label: '6. Garantie si Suport Post-Vanzare',
        roText: `<h2>6. Garantie si Suport Post-Vanzare</h2><p>Produsele hardware beneficiaza de garantie legala de 24 de luni pentru persoane fizice, respectiv 12 luni pentru persoane juridice, conform OG 9/2021 si Legii nr. 449/2003. Serviciile software beneficiaza de garantie de functionare de 30-90 de zile (specificat in contract). Suportul tehnic post-garantie se asigura contra cost, conform tarifelor in vigoare.</p>`,
        enText: `<h2>6. Warranty and After-Sales Support</h2><p>Hardware products carry a 24-month legal warranty for consumers and 12 months for businesses, per GO 9/2021 and Law 449/2003. Software services carry a 30-90 day operational warranty (specified in contract). Post-warranty technical support is provided for a fee per current rates.</p>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_7', label: '7. Limitarea Raspunderii',
        roText: `<h2>7. Limitarea Raspunderii</h2><p>Interpersonal nu raspunde pentru: (a) daune indirecte, pierderi de profit sau oportunitati de afaceri rezultate din utilizarea/neutilizarea serviciilor; (b) intreruperi ale serviciilor cauzate de factori externi (furnizori terti, internet, cazuri de forta majora); (c) date pierdute ca urmare a neglijentei Clientului. Raspunderea maxima a Interpersonal in orice situatie este limitata la valoarea contractului in cauza.</p>`,
        enText: `<h2>7. Limitation of Liability</h2><p>Interpersonal is not liable for: (a) indirect damages, loss of profit or business opportunities from use/non-use of services; (b) service interruptions caused by external factors (third-party providers, internet, force majeure); (c) data loss due to Client negligence. Interpersonal maximum liability in any situation is limited to the value of the relevant contract.</p>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_8', label: '8. Rezilierea Contractului',
        roText: `<h2>8. Rezilierea Contractului</h2><p>Oricare parte poate rezilia contractul cu 30 de zile preaviz scris. Interpersonal poate rezilia imediat contractul in caz de neplata, utilizare frauduloasa sau incalcare grava a T&amp;C. In caz de reziliere din culpa Clientului, Interpersonal retine sumele achitate aferente lucrarilor efectuate.</p>`,
        enText: `<h2>8. Contract Termination</h2><p>Either party may terminate the contract with 30 days written notice. Interpersonal may immediately terminate in case of non-payment, fraudulent use, or serious breach of T&amp;C. In case of termination due to Client fault, Interpersonal retains amounts paid for work already performed.</p>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_9', label: '9. Protectia Datelor Personale',
        roText: `<h2>9. Protectia Datelor Personale</h2><p>Prelucrarea datelor personale se face in conformitate cu RGPD (Regulamentul UE 2016/679) si legislatia nationala de implementare. Detalii complete in Politica de Confidentialitate disponibila pe site. Prin utilizarea serviciilor noastre, acceptati prelucrarea datelor in scopurile descrise in politica de confidentialitate.</p>`,
        enText: `<h2>9. Personal Data Protection</h2><p>Personal data processing complies with GDPR (EU Regulation 2016/679) and national implementing legislation. Full details in the Privacy Policy available on the website. By using our services, you accept data processing for the purposes described in the privacy policy.</p>`,
        imageUrl: ''
      },
      {
        id: 's_termeni_10', label: '10. Legea Aplicabila si Jurisdictia',
        roText: `<h2>10. Legea Aplicabila si Jurisdictia</h2><p>Prezentele T&amp;C sunt guvernate de legislatia romana. Orice litigiu va fi solutionat pe cale amiabila. In cazul imposibilitatii solutionarii amiabile, competenta revine instantelor judecatoresti de la sediul Interpersonal (Jud. Ilfov), conform Codului de Procedura Civila. Data ultimei actualizari: 01 Ianuarie 2026.</p>`,
        enText: `<h2>10. Applicable Law and Jurisdiction</h2><p>These T&amp;C are governed by Romanian law. Any dispute shall first be resolved amicably. If amicable resolution is impossible, jurisdiction belongs to the courts at Interpersonal registered seat (Ilfov County), per the Civil Procedure Code. Last updated: 01 January 2026.</p>`,
        imageUrl: ''
      }
    ]
  },
  /* ── Politica de Confidentialitate ───────────────────────────────────── */
  {
    id: 'confidentialitate', pageId: 'confidentialitate', pageName: 'Politica de Confidentialitate', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_gdpr_1', label: '1. Identitatea Operatorului',
        roText: `<h2>1. Identitatea Operatorului</h2><p>INTERPERSONAL S.R.L., cu sediul in Str. Orhideelor nr. 8, Sat Teghes, Com. Domnesti, Jud. Ilfov, 077091, CUI RO34799221, J2015002538235, EUID ROONRC.J2015002538235, email: office@interpersonal.ro, telefon: +40 741 407 595, este operatorul datelor cu caracter personal prelucrate in cadrul activitatii sale comerciale, in calitate de operator in sensul Regulamentului (UE) 2016/679 (RGPD).</p>`,
        enText: `<h2>1. Data Controller Identity</h2><p>INTERPERSONAL S.R.L., registered at Str. Orhideelor nr. 8, Sat Teghes, Com. Domnesti, Ilfov County, 077091, VAT RO34799221, J2015002538235, EUID ROONRC.J2015002538235, email: office@interpersonal.ro, tel: +40 741 407 595, is the data controller of personal data processed in its commercial activity, as controller under Regulation (EU) 2016/679 (GDPR).</p>`,
        imageUrl: ''
      },
      {
        id: 's_gdpr_2', label: '2. Datele Colectate',
        roText: `<h2>2. Datele Colectate</h2><ul><li>Date de identificare: nume, prenume, CNP (pentru persoane fizice)</li><li>Date de contact: adresa email, numar de telefon, adresa postala</li><li>Date profesionale: denumire firma, CUI, functie, sector de activitate</li><li>Date de navigare: adresa IP, tip browser, pagini vizitate, durata sesiune (cookies)</li><li>Date tranzactionale: istoricul comenzilor, facturi, plati</li><li>Comunicari: continutul mesajelor trimise prin formularul de contact</li></ul>`,
        enText: `<h2>2. Data Collected</h2><ul><li>Identification data: first name, last name, national ID (for individuals)</li><li>Contact data: email address, phone number, postal address</li><li>Professional data: company name, VAT number, role, business sector</li><li>Browsing data: IP address, browser type, pages visited, session duration (cookies)</li><li>Transaction data: order history, invoices, payments</li><li>Communications: content of messages sent through the contact form</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_gdpr_3', label: '3. Scopul si Temeiul Juridic al Prelucrarii',
        roText: `<h2>3. Scopul si Temeiul Juridic al Prelucrarii</h2><ul><li>Executarea contractului (Art. 6 alin. 1 lit. b RGPD): livrarea serviciilor comandate, facturare, suport tehnic</li><li>Obligatii legale (Art. 6 alin. 1 lit. c RGPD): raportari fiscale, contabilitate conform Codului Fiscal si Legii 82/1991</li><li>Interes legitim (Art. 6 alin. 1 lit. f RGPD): securitatea sistemelor informatice, prevenirea fraudei, marketing direct fata de clienti existenti</li><li>Consimtamant (Art. 6 alin. 1 lit. a RGPD): newsletter, cookies non-esentiale, comunicari promotionale</li></ul>`,
        enText: `<h2>3. Purpose and Legal Basis of Processing</h2><ul><li>Contract performance (Art. 6(1)(b) GDPR): delivering ordered services, invoicing, technical support</li><li>Legal obligations (Art. 6(1)(c) GDPR): tax reporting, accounting per Fiscal Code and Law 82/1991</li><li>Legitimate interest (Art. 6(1)(f) GDPR): IT system security, fraud prevention, direct marketing to existing clients</li><li>Consent (Art. 6(1)(a) GDPR): newsletter, non-essential cookies, promotional communications</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_gdpr_4', label: '4. Perioada de Stocare',
        roText: `<h2>4. Perioada de Stocare</h2><p>Datele contractuale si financiare se pastreaza 10 ani de la data documentului, conform Legii 82/1991 (contabilitate). Datele de marketing se sterg la retragerea consimtamantului sau la cerere. Datele de navigare (logs) se pastreaza maximum 12 luni. Datele de suport tehnic se retin 3 ani de la rezolvarea solicitarii.</p>`,
        enText: `<h2>4. Retention Period</h2><p>Contractual and financial data are retained for 10 years from document date per Law 82/1991 (accounting). Marketing data are deleted upon withdrawal of consent or upon request. Navigation data (logs) are retained for a maximum of 12 months. Technical support data are retained for 3 years after resolution.</p>`,
        imageUrl: ''
      },
      {
        id: 's_gdpr_5', label: '5. Drepturile Persoanelor Vizate',
        roText: `<h2>5. Drepturile Persoanelor Vizate</h2><ul><li>Dreptul de acces (Art. 15 RGPD): puteti solicita o copie a datelor prelucrate</li><li>Dreptul la rectificare (Art. 16 RGPD): corectarea datelor inexacte</li><li>Dreptul la stergere ("dreptul de a fi uitat") - Art. 17 RGPD</li><li>Dreptul la restrictionarea prelucrarii (Art. 18 RGPD)</li><li>Dreptul la portabilitate (Art. 20 RGPD): export date in format structurat</li><li>Dreptul la opozitie (Art. 21 RGPD): inclusiv fata de prelucrarea in scop de marketing</li><li>Dreptul de a depune plangere la ANSPDCP (www.dataprotection.ro)</li></ul>`,
        enText: `<h2>5. Rights of Data Subjects</h2><ul><li>Right of access (Art. 15 GDPR): you may request a copy of processed data</li><li>Right to rectification (Art. 16 GDPR): correction of inaccurate data</li><li>Right to erasure ("right to be forgotten") - Art. 17 GDPR</li><li>Right to restriction of processing (Art. 18 GDPR)</li><li>Right to data portability (Art. 20 GDPR): export in structured format</li><li>Right to object (Art. 21 GDPR): including to processing for marketing purposes</li><li>Right to lodge a complaint with ANSPDCP (www.dataprotection.ro)</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_gdpr_6', label: '6. Securitatea Datelor si Contact DPO',
        roText: `<h2>6. Securitatea Datelor si Contact DPO</h2><p>Interpersonal implementeaza masuri tehnice si organizatorice adecvate pentru protectia datelor, conform Art. 32 RGPD: criptare TLS/SSL pentru transmisii, acces restricționat la date, backup regulat, politici interne de securitate, audit periodic. Pentru exercitarea drepturilor sau orice intrebari RGPD: office@interpersonal.ro | INTERPERSONAL S.R.L., Str. Orhideelor nr. 8, Sat Teghes, Com. Domnesti, Jud. Ilfov, 077091. Raspundem in termen de 30 de zile calendaristice.</p>`,
        enText: `<h2>6. Data Security and DPO Contact</h2><p>Interpersonal implements appropriate technical and organizational measures for data protection per Art. 32 GDPR: TLS/SSL encryption for transmissions, restricted data access, regular backups, internal security policies, periodic audits. To exercise your rights or for any GDPR questions: office@interpersonal.ro | INTERPERSONAL S.R.L., Str. Orhideelor nr. 8, Sat Teghes, Com. Domnesti, Ilfov County, 077091. We respond within 30 calendar days.</p>`,
        imageUrl: ''
      }
    ]
  },
  /* ── Politica Cookies ────────────────────────────────────────────────── */
  {
    id: 'cookies', pageId: 'cookies', pageName: 'Politica Cookies', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_ck_1', label: '1. Ce Sunt Cookie-urile',
        roText: `<h2>1. Ce Sunt Cookie-urile</h2><p>Cookie-urile sunt fisiere text de mici dimensiuni care sunt stocate pe dispozitivul dvs. (calculator, telefon, tableta) atunci cand vizitati un site web. Ele permit site-ului sa memoreze preferintele dvs., sa imbunatateasca experienta de navigare si sa furnizeze statistici despre utilizare. Prezenta politica este elaborata conform Directivei ePrivacy (2002/58/CE, amendată prin 2009/136/CE) si Regulamentului RGPD (UE) 2016/679.</p>`,
        enText: `<h2>1. What Are Cookies</h2><p>Cookies are small text files stored on your device (computer, phone, tablet) when you visit a website. They allow the site to remember your preferences, improve browsing experience and provide usage statistics. This policy is prepared in accordance with the ePrivacy Directive (2002/58/EC, amended by 2009/136/EC) and GDPR Regulation (EU) 2016/679.</p>`,
        imageUrl: ''
      },
      {
        id: 's_ck_2', label: '2. Tipuri de Cookie-uri Utilizate',
        roText: `<h2>2. Tipuri de Cookie-uri Utilizate</h2><ul><li>Cookie-uri Strict Necesare (Tehnice): esentiale pentru functionarea site-ului, nu necesita consimtamant. Nu pot fi dezactivate.</li><li>Cookie-uri Analitice/Performanta: colecteaza informatii anonimizate despre cum vizitatorii utilizeaza site-ul (Google Analytics). Necesita consimtamantul dvs.</li><li>Cookie-uri de Functionalitate: memoreaza preferintele dvs. (limba, regiune, setari). Necesita consimtamant.</li><li>Cookie-uri de Marketing/Publicitate: utilizate pentru personalizarea reclamelor si urmarirea conversiilor. Necesita consimtamant explicit.</li></ul>`,
        enText: `<h2>2. Types of Cookies Used</h2><ul><li>Strictly Necessary (Technical) Cookies: essential for site operation, do not require consent. Cannot be disabled.</li><li>Analytical/Performance Cookies: collect anonymized information about how visitors use the site (Google Analytics). Require your consent.</li><li>Functionality Cookies: remember your preferences (language, region, settings). Require consent.</li><li>Marketing/Advertising Cookies: used for personalized advertising and conversion tracking. Require explicit consent.</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_ck_3', label: '3. Lista Detaliata si Durata Cookie-urilor',
        roText: `<h2>3. Lista Detaliata a Cookie-urilor</h2><ul><li>lang (First-party, Sesiune): Memoreaza preferinta de limba (RO/EN). Strict necesar.</li><li>_ga, _gid, _gat (Third-party, Google Analytics, 2 ani / 24h / 1 min): Statistici anonime de utilizare. Analitic.</li><li>cookieconsent_status (First-party, 1 an): Retine alegerea dvs. privind cookie-urile. Strict necesar.</li><li>fbpx/Meta Pixel (Third-party, 90 zile): Urmarire conversii Facebook/Instagram. Marketing.</li></ul><p>Cookie-urile de sesiune se sterg automat la inchiderea browserului. Puteti sterge oricand cookie-urile prin setarile browserului.</p>`,
        enText: `<h2>3. Detailed Cookie List and Duration</h2><ul><li>lang (First-party, Session): Stores language preference (RO/EN). Strictly necessary.</li><li>_ga, _gid, _gat (Third-party, Google Analytics, 2 years / 24h / 1 min): Anonymous usage statistics. Analytical.</li><li>cookieconsent_status (First-party, 1 year): Stores your cookie choice. Strictly necessary.</li><li>fbpx/Meta Pixel (Third-party, 90 days): Facebook/Instagram conversion tracking. Marketing.</li></ul><p>Session cookies are automatically deleted when you close your browser. You can delete stored cookies at any time through browser settings.</p>`,
        imageUrl: ''
      },
      {
        id: 's_ck_4', label: '4. Consimtamant si Gestionare Cookie-uri',
        roText: `<h2>4. Consimtamant si Gestionare Cookie-uri</h2><p>La prima vizita pe site, este afisat un banner de consimtamant pentru cookie-uri. Puteti accepta toate cookie-urile, le puteti refuza pe cele non-esentiale sau puteti personaliza preferintele. Consimtamantul este inregistrat si poate fi retras oricand.</p><p>Puteti gestiona cookie-urile din setarile browserului: Chrome, Firefox, Safari, Edge. Pentru opt-out Google Analytics: tools.google.com/dlpage/gaoptout. Contact: office@interpersonal.ro.</p>`,
        enText: `<h2>4. Consent and Cookie Management</h2><p>On your first site visit, a cookie consent banner is displayed. You can accept all cookies, refuse non-essential ones, or customize preferences. Consent is recorded and can be withdrawn at any time.</p><p>You can manage cookies via browser settings: Chrome, Firefox, Safari, Edge. For Google Analytics opt-out: tools.google.com/dlpage/gaoptout. Contact: office@interpersonal.ro.</p>`,
        imageUrl: ''
      }
    ]
  },
  /* ── Politica de Retur ───────────────────────────────────────────────── */
  {
    id: 'retur', pageId: 'retur', pageName: 'Politica de Retur', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_ret_1', label: '1. Cadrul Legal',
        roText: `<h2>1. Cadrul Legal</h2><p>Prezenta Politica de Retur si Returnare este elaborata in conformitate cu: Ordonanta de Urgenta nr. 34/2014 privind drepturile consumatorilor in cadrul contractelor incheiate cu profesionistii (transpunand Directiva UE 2011/83/UE); Legea nr. 449/2003 privind vanzarea produselor si garantiile asociate acestora, cu modificarile aduse de OG nr. 9/2021; Legea nr. 363/2007 privind combaterea practicilor incorecte ale comerciantilor; Regulamentul (UE) 2022/2065 privind Piata Unica pentru Servicii Digitale.</p>`,
        enText: `<h2>1. Legal Framework</h2><p>This Return and Refund Policy is elaborated in accordance with: Government Emergency Ordinance No. 34/2014 on consumer rights in contracts concluded with professionals (transposing EU Directive 2011/83/EU); Law No. 449/2003 on the sale of goods and associated guarantees, amended by GO No. 9/2021; Law No. 363/2007 on combating unfair commercial practices; Regulation (EU) 2022/2065 on the Digital Single Market.</p>`,
        imageUrl: ''
      },
      {
        id: 's_ret_2', label: '2. Serviciile INTERPERSONAL sunt Nerambursabile',
        roText: `<h2>2. Serviciile INTERPERSONAL sunt Nerambursabile</h2><p>Serviciile prestate de INTERPERSONAL S.R.L. (web design, programare, call center, VoIP, CRM, consultanta IT) sunt NERETURNABILE si NERAMBURSABILE, conform exceptiilor prevazute la art. 16 lit. a) si c) din OUG 34/2014.</p><ul><li>Odata ce prestarea unui serviciu a inceput cu acordul expres al clientului, dreptul de retragere NU se mai poate exercita.</li><li>Avansul achitat la semnarea contractului de servicii nu se ramburseaza in nicio situatie.</li><li>Serviciile de hosting activate, conturile VoIP deschise si licentele software activate nu sunt rambursabile dupa activare.</li></ul>`,
        enText: `<h2>2. INTERPERSONAL Services are Non-Refundable</h2><p>Services provided by INTERPERSONAL S.R.L. (web design, programming, call center, VoIP, CRM, IT consulting) are NON-RETURNABLE and NON-REFUNDABLE, per the exceptions under art. 16 lit. a) and c) of GEO 34/2014.</p><ul><li>Once the performance of a service has begun with the client express consent, the right of withdrawal can NO LONGER be exercised.</li><li>The advance payment made upon signing a service contract is non-refundable under any circumstances.</li><li>Activated hosting services, opened VoIP accounts and activated software licenses are non-refundable after activation.</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_ret_3', label: '3. Dreptul de Retragere — Produse Hardware',
        roText: `<h2>3. Dreptul de Retragere — Produse Hardware (Persoane Fizice)</h2><p>Consumatorii persoane fizice care achizitioneaza produse hardware (calculatoare, laptopuri, periferice) au dreptul de retragere de 14 zile calendaristice de la data primirii fizice a produsului, conform OUG 34/2014 art. 9 alin. 1. Dreptul de retragere se exercita prin notificare scrisa la office@interpersonal.ro.</p><p>Starea produsului returnat: nefolosit, nedeteriorat, in ambalajul original intact cu toate sigiliile intacte. Toate accesoriile, cabluri, manuale, certificat de garantie trebuie incluse.</p>`,
        enText: `<h2>3. Right of Withdrawal — Hardware Products (Individuals)</h2><p>Consumer individuals purchasing hardware products (computers, laptops, peripherals) have a 14-day right of withdrawal from the date of physical receipt of the product, per GEO 34/2014 art. 9 para. 1. The right of withdrawal is exercised by written notification to office@interpersonal.ro.</p><p>Product condition: unused, undamaged, in intact original packaging with all seals intact. All accessories, cables, manuals, warranty certificate must be included.</p>`,
        imageUrl: ''
      },
      {
        id: 's_ret_4', label: '4. Rambursarea si Garantia',
        roText: `<h2>4. Rambursarea si Garantia Legala</h2><p>Rambursarea se efectueaza prin acelasi mijloc de plata utilizat la achizitie (transfer bancar, card bancar, numerar la sediu), in maximum 30 de zile calendaristice de la primirea si verificarea produsului returnat. Interpersonal nu percepe comisioane suplimentare pentru rambursare.</p><p>Produsele hardware noi beneficiaza de garantie legala de conformitate: 2 ani pentru persoane fizice, 1 an pentru persoane juridice, de la data livrarii, conform Legii 449/2003 si OG 9/2021.</p><p>Contact: office@interpersonal.ro | +40 741 407 595 | Program: Luni-Vineri, 09:00-18:00</p>`,
        enText: `<h2>4. Refunds and Legal Warranty</h2><p>Refunds are made through the same payment method used at purchase (bank transfer, credit card, cash at office), within a maximum of 30 calendar days from receipt and verification of the returned product. Interpersonal charges no additional commissions for refunds.</p><p>New hardware products benefit from legal conformity guarantee: 2 years for individuals, 1 year for legal entities, from delivery date, per Law 449/2003 and GO 9/2021.</p><p>Contact: office@interpersonal.ro | +40 741 407 595 | Hours: Monday-Friday, 09:00-18:00</p>`,
        imageUrl: ''
      }
    ]
  },
  /* ── Acord de Confidentialitate (NDA) ───────────────────────────────── */
  {
    id: 'nda', pageId: 'nda', pageName: 'Acord de Confidentialitate NDA', updatedAt: '2026-05-01',
    sections: [
      {
        id: 's_nda_1', label: '1. Scopul Acordului',
        roText: `<h2>1. Scopul Acordului</h2><p>Prezentul Acord de Confidentialitate si Nedivulgare (NDA - Non-Disclosure Agreement) stabileste obligatiile de confidentialitate intre INTERPERSONAL S.R.L. (denumit in continuare "Prestatorul") si Client/Partener (denumit in continuare "Partea Receptoare"), cu privire la informatiile confidentiale schimbate in cadrul colaborarii sau negocierilor comerciale. Acordul se aplica oricarei comunicari verbale, scrise, electronice sau materiale tehnice schimbate intre cele doua parti.</p>`,
        enText: `<h2>1. Purpose of Agreement</h2><p>This Non-Disclosure Agreement (NDA) establishes confidentiality obligations between INTERPERSONAL S.R.L. (hereinafter "Provider") and the Client/Partner (hereinafter "Receiving Party"), regarding confidential information exchanged during collaboration or commercial negotiations. The agreement applies to any verbal, written, electronic communications or technical materials exchanged between the two parties.</p>`,
        imageUrl: ''
      },
      {
        id: 's_nda_2', label: '2. Definitia Informatiilor Confidentiale',
        roText: `<h2>2. Definitia Informatiilor Confidentiale</h2><ul><li>Date tehnice: coduri sursa, arhitecturi software, specificatii tehnice, baze de date</li><li>Date comerciale: preturi, strategii de afaceri, liste de clienti, proiecte in derulare</li><li>Date financiare: bugete, rapoarte financiare, conditii contractuale specifice</li><li>Date de personal: informatii despre angajati, structura organizatorica interna</li><li>Date ale clientilor Interpersonal: orice informatii despre terti primite in cadrul colaborarii</li><li>Proprietate intelectuala: inventii, concepte, metode de lucru, know-how proprietar</li><li>Orice informatie marcata "Confidential" sau transmisa in context evident confidential</li></ul>`,
        enText: `<h2>2. Definition of Confidential Information</h2><ul><li>Technical data: source code, software architectures, technical specifications, databases</li><li>Commercial data: prices, business strategies, client lists, ongoing projects</li><li>Financial data: budgets, financial reports, specific contractual terms</li><li>Personnel data: information about employees, internal organizational structure</li><li>Interpersonal client data: any information about third parties received during collaboration</li><li>Intellectual property: inventions, concepts, working methods, proprietary know-how</li><li>Any information marked "Confidential" or transmitted in an obviously confidential context</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_nda_3', label: '3. Obligatiile Partii Receptoare',
        roText: `<h2>3. Obligatiile Partii Receptoare</h2><ul><li>Sa pastreze strict confidentiale toate informatiile primite de la Interpersonal</li><li>Sa nu divulge, publice, transmita sau puna la dispozitia tertilor informatiile confidentiale</li><li>Sa utilizeze informatiile exclusiv in scopul colaborarii convenite</li><li>Sa restrictioneze accesul intern la informatii strict la persoanele care au nevoie de acestea</li><li>Sa implementeze masuri de securitate cel putin egale cu cele utilizate pentru propriile date confidentiale</li><li>Sa notifice imediat Interpersonal in caz de divulgare neautorizata sau incident de securitate</li></ul>`,
        enText: `<h2>3. Obligations of the Receiving Party</h2><ul><li>Strictly maintain confidentiality of all information received from Interpersonal</li><li>Not disclose, publish, transmit or make available to third parties the confidential information</li><li>Use information exclusively for the purposes of the agreed collaboration</li><li>Restrict internal access to information strictly to those who need it</li><li>Implement security measures at least equal to those used for their own confidential data</li><li>Immediately notify Interpersonal in case of unauthorized disclosure or security incident</li></ul>`,
        imageUrl: ''
      },
      {
        id: 's_nda_4', label: '4. Durata, Exceptii si Consecinte',
        roText: `<h2>4. Durata, Exceptii si Consecintele Incalcarii</h2><p>Obligatiile de confidentialitate se aplica pe durata colaborarii si continua timp de 5 ani dupa incetarea acesteia. Pentru informatiile referitoare la date personale ale tertilor, obligatiile sunt nelimitate in timp, conform RGPD.</p><p>Exceptii: informatii care devin publice fara culpa partii receptoare, informatii cunoscute anterior si independent, informatii primite de la un tert neobligat de confidentialitate, sau divulgari impuse de lege sau autoritati.</p><p>Orice incalcare atrage raspunderea contractuala, daune, si actiuni civile/penale conform Legii 8/1996 si Codului Penal.</p><p>Acceptarea: Utilizarea serviciilor Interpersonal sau semnarea oricarui contract constituie acceptarea implicita a prezentului NDA. Contact: office@interpersonal.ro.</p>`,
        enText: `<h2>4. Duration, Exceptions and Consequences of Breach</h2><p>Confidentiality obligations apply during the collaboration and continue for 5 years after its termination. For information regarding personal data of third parties, obligations are unlimited in time per GDPR.</p><p>Exceptions: information that becomes public without fault of the receiving party, information already known independently, information received from a third party not bound by confidentiality, or disclosures required by law or regulatory authorities.</p><p>Any breach triggers contractual liability, damages, and civil/criminal actions under Law 8/1996 and Criminal Code.</p><p>Acceptance: Using Interpersonal services or signing any contract constitutes implicit acceptance of this NDA. Contact: office@interpersonal.ro.</p>`,
        imageUrl: ''
      }
    ]
  },
];

/* ── Default Clients ─────────────────────────────────────────────────────── */
export const defaultClients: Client[] = [];
export const defaultOrders: Order[] = [];
